(() => {
  "use strict";
  var e = {
      d: (t, s) => {
        for (var i in s)
          e.o(s, i) &&
            !e.o(t, i) &&
            Object.defineProperty(t, i, { enumerable: !0, get: s[i] });
      },
      o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
      r: (e) => {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(e, "__esModule", { value: !0 });
      },
    },
    t = {};
  function s() {
    return new Promise(function (e, t) {
      "loading" !== document.readyState
        ? e()
        : addEventListener("DOMContentLoaded", () => {
            e();
          });
    });
  }
  e.r(t),
    e.d(t, {
      ProductForm: () => ProductForm,
      ProductSmartRelated: () => Q,
      ProductStickyAtc: () => ProductStickyAtc,
    });
  class ObserverLite {
    constructor(e) {
      if (
        ((e = e || {}),
        (this.id = Math.floor(999999999999 * Math.random())),
        (this.settings = e),
        e.key)
      ) {
        if (
          ((window.GlobalObersverLiteInstances =
            window.GlobalObersverLiteInstances || {}),
          window.GlobalObersverLiteInstances[e.key])
        )
          return window.GlobalObersverLiteInstances[e.key];
        window.GlobalObersverLiteInstances[e.key] = this;
      }
    }
    once() {
      return new Promise((e, t) => {
        this.onceDone && e(this.onceDone);
        const s = this.subscribe((t) => {
          (t = t || !0), (this.onceDone = t), e(t), this.unsubscribe(s);
        });
      });
    }
    setOnce(e) {
      (e = e || !0), (this.onceDone = e);
    }
    next(...e) {
      this.onceDone || this.setOnce(...e),
        this.subject &&
          this.subject.length &&
          this.subject.forEach(({ callback: t }) => {
            t(...e);
          });
    }
    subscribe(e) {
      return (
        (this.subject = this.subject || []),
        (e = { callback: e, id: Math.floor(1e14 + 9e14 * Math.random()) }),
        this.subject.push(e),
        e
      );
    }
    unsubscribe(e) {
      this.subject = this.subject.filter(({ id: t }) => t !== e.id);
    }
    unsubscribeAll(e) {
      this.subject?.forEach((e) => this.unsubscribe(e)),
        e && (this.onceDone = !1);
    }
  }
  class ShopifyUtils {
    constructor() {
      this.money_format =  moneyfomat;
    }
    handleize(e) {
      return e
        .toLowerCase()
        .replace(/[^\w\u00C0-\u024f]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }
    parseImgUrl(e, t) {
      const s = e.includes(".png") ? "png" : "jpg";
      return `${e.split("png" == s ? ".png" : ".jpg")[0]}_${t}x.${s}`;
    }
    formatMoney(e, t) {
      "string" == typeof e && (e = e.replace(".", ""));
      var s = "",
        i = /\{\{\s*(\w+)\s*\}\}/,
        r = t || this.money_format;
      function n(e, t) {
        return void 0 === e ? t : e;
      }
      function a(e, t, s, i) {
        if (
          ((t = n(t, 2)),
          (s = n(s, ",")),
          (i = n(i, ".")),
          isNaN(e) || null == e)
        )
          return 0;
        var r = (e = (e / 100).toFixed(t)).split(".");
        return (
          r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s) +
          (r[1] ? i + r[1] : "")
        );
      }
      switch (r.match(i)[1]) {
        case "amount":
          s = a(e, 2);
          break;
        case "amount_no_decimals":
          s = a(e, 0);
          break;
        case "amount_with_comma_separator":
          s = a(e, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          s = a(e, 0, ".", ",");
      }
      return r.replace(i, s);
    }
  }
  class GlobalCart {
    constructor(e) {
      return (
        (window.GlobalCartObserver$ =
          window.GlobalCartObserver$ || new ObserverLite()),
        window.GlobalCartSingleton
          ? new Promise((e, t) => {
              window.GlobalCartObserver$.loaded
                ? e(window.GlobalCartSingleton)
                : window.GlobalCartObserver$.subscribe(() => {
                    e(window.GlobalCartSingleton);
                  });
            })
          : e
          ? ((window.GlobalCartSingleton = this),
            (this.ObserverLite = new ObserverLite()),
            (this.ShopifyUtils = new ShopifyUtils({
              money_format: e.money_format || !1,
            })),
            this.subscribe(() => {
              (window.GlobalCartObserver$.loaded = !0),
                window.GlobalCartObserver$.next();
            }),
            void this.updateData())
          : new Promise((e, t) => {
              window.GlobalCartObserver$.subscribe(() => {
                e(window.GlobalCartSingleton);
              });
            })
      );
    }
    subscribe(e) {
      return this.ObserverLite.subscribe(e);
    }
    next(e) {
      this.ObserverLite.next(e);
    }
    serialize(e) {
      const t = {};
      function s(e, t, s) {
        const i = t.pop();
        let r = e;
        for (const e of t) r[e] || (r[e] = {}), (r = r[e]);
        r[i] = s;
      }
      const i = new FormData(e);
      for (let [e, r] of i.entries()) {
        s(
          t,
          e.split("[").map((e) => e.replace("]", "")),
          r
        );
      }
      return t;
    }
    addViaForm(e) {
      let t = this.serialize(e);
      return (
        (t.quantity = parseInt(t.quantity)),
        (t = { items: [t] }),
        this.addToCart(t)
      );
    }
    addToCart(e) {
      return new Promise((t, s) => {
        e || s({ description: "Sorry, there was a problem with that request" }),
          fetch("/cart/add.js", {
            method: "POST",
            body: JSON.stringify(e),
            headers: { "Content-Type": "application/json" },
          })
            .then((e) => e.json())
            .then((e) => {
              if (!e) throw e;
              this.updateData(), t();
            })
            .catch((e) => {
              console.log(e), s(e);
            });
      });
    }
    updateData() {
      return new Promise((e, t) => {
        this.getCartJSON().then((t) => {
          (this.cart = t), this.next({ eventType: "update" }), e();
        });
      });
    }
    updateQty(e, t) {
      let s = [{ key: e.key, qty: t }];
      console.log(s),
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            updates: s.reduce((e, t) => ({ ...e, [t.key]: t.qty }), {}),
          }),
        })
          .then((e) => e.json())
          .then((e) => {
            if (!e.token) throw e;
            this.updateData().then(() => {
              this.next({ eventType: "update" });
            });
          })
          .catch((e) => {
            this.next({ eventType: "error", error: e });
          });
    }
    removeItem(e) {
      fetch(e).then((e) => {
        this.updateData().then(() => {
          this.next({ eventType: "update" });
        });
      });
    }
    getCartJSON() {
      return new Promise((e, t) => {
        fetch("/cart.js")
          .then((e) => e.json())
          .then((t) => {
            e(t);
          });
      });
    }
    getLineItemsByVariantId(e) {
      return (
        (e = parseInt(e)),
        this.cart && this.cart.items
          ? this.cart.items.filter(({ variant_id: t }) => t == e)
          : []
      );
    }
    getLineItemsByProperty(e, t) {
      return this.cart && this.cart.items
        ? this.cart.items.filter((s) => {
            let i = s.properties?.[e];
            return (i = !!((null == t && i) || (i && i == t))), i;
          })
        : [];
    }
  }
  class ProductForm extends HTMLElement {
    constructor() {
      super(), (this.ObserverLite = new ObserverLite());
    }
    subscribe(e) {
      return this.ObserverLite.subscribe(e);
    }
    next(e) {
      this.ObserverLite.next(e);
    }
    async connectedCallback() {
      (this.GlobalCart = await new GlobalCart()),
        (this.variant =
          !!this.attributes.variant &&
          JSON.parse(this.attributes.variant.value)),
        (this.translations =
          !!this.attributes.translations &&
          JSON.parse(this.attributes.translations.value)),
        (this.observer_key = this.attributes.observer_key?.value || !1),
        !this.init &&
          this.variant &&
          s()
            .then(() => {
              this.build();
            })
            .catch((e) => {
              console.log(e);
            });
    }
    build() {
      if (
        ((this.init = !0),
        (this.cart = document.querySelector("global-sidebar-cart")),
        (this.productForm = this.querySelector("form")),
        (this.productSelectors = this.querySelector(
          ".js-product-main__option-selectors"
        )),
        (this.productSelectedVariantId = this.querySelector(
          ".js-product-main__variant_id"
        )),
        (this.productPrice = document.querySelector(".js-product-main__price")),
        (this.ATCBtn = this.querySelector(".js-product-main__atc")),
        this.onProductVariantChange(this.variant),
        this.observer_key)
      ) {
        new ObserverLite({ key: this.observer_key }).next(this);
      }
      this.productSelectors &&
        this.productSelectors.subscribe(() => {
          this.onProductVariantChange(this.productSelectors.selectedVariant);
        }),
        this.productForm.addEventListener(
          "submit",
          (e) => (e.preventDefault(), this.addToCart(), !1)
        );
    }
    addToCart() {
      this.cart.toggle(), this.cart.addToCart(this.productForm);
    }
    updateUrlWithNewVariant(e) {
      const t = new URL(window.location);
      t.searchParams.set("variant", e),
        window.history.replaceState({ path: t.href }, "", t.href);
    }
    onProductVariantChange(e) {
      var variantData = document.getElementById("variant-json");
      var variantData = JSON.parse(variantData.textContent);

      var current_id = e.id;
      var matchingVariant = variantData.metafields.find(function (variant) {
        return variant.id == current_id;
      });

      // console.log("matchingVariant",matchingVariant.delivery_day);
      const now = new Date();
      const hours = now.getHours();
      const currentTime = `${hours}:00:00`;
      // console.log("currentTime", currentTime);

      if (hours < 18) {
        if (matchingVariant.delivery_day != "") {
          commonTimeFun(matchingVariant);
        } else {
          // document.querySelector(".prod-below-atc__text").innerHTML =
          //   "Order before 6pm for next day delivery";
        }
      } else {
        if (matchingVariant.delivery_day != "") {
          commonTimeFun(matchingVariant);
        } else {
          // document.querySelector(".prod-below-atc__text").innerHTML =
          //   "Order before 6pm for next day delivery";
        }
      }
      var discount_priceDiv = document.querySelector(".discount_price");
      if (discount_priceDiv) {
        if (e.compare_at_price > e.price) {
          var price = e.price;
          var Cprice = e.compare_at_price;
          var discount_price = Cprice - price;
          console.log(
            this.GlobalCart.ShopifyUtils.formatMoney(discount_price),
            "discount_price"
          );
          var discount_priceDiv = document.querySelector(".discount_price");
          discount_priceDiv.innerHTML =
            "Save " + this.GlobalCart.ShopifyUtils.formatMoney(discount_price);
          discount_priceDiv.style.display = "block";
        } else {
          var discount_priceDiv = document.querySelector(".discount_price");
          discount_priceDiv.style.display = "none";
        }
      }

      this.productSelectedVariantId.value = e.id;
      document.querySelectorAll(".gf-variant-image").forEach(function (img) {
        img.style.display = img.dataset.variant == e.id ? "block" : "none";
      });
      
      const t = e.compare_at_price && e.compare_at_price != e.price;
      (this.productPrice.innerHTML = `<span class="${
        t ? "t-red" : ""
      }">\n                                 ${this.GlobalCart.ShopifyUtils.formatMoney(
        e.price
      )}\n                                 </span>\n                                 ${
        t
          ? `<span class="t-r d-block"><strike>${this.GlobalCart.ShopifyUtils.formatMoney(
              e.compare_at_price
            )}</strike></span>`
          : ""
      }`),
        (this.ATCBtn.disabled = !e.available),
        (this.ATCBtn.innerHTML = e.available
          ? matchingVariant.status != ""
            ? matchingVariant.status
            : this.translations.add_to_cart
          : this.translations.sold_out);
      (this.variant = e), this.updateUrlWithNewVariant(e.id), this.next();
    }
  }
  customElements.define("product-form", ProductForm);
  class ProductStickyAtc extends HTMLElement {
    constructor() {
      super(), (this.ShopifyUtils = new ShopifyUtils());
    }
    connectedCallback() {
      (this.variant =
        !!this.attributes.variant && JSON.parse(this.attributes.variant.value)),
        !this.init &&
          this.variant &&
          s()
            .then(() => {
              this.build();
            })
            .catch((e) => {
              console.log(e);
            });
    }
    build() {
      (this.init = !0),
        (this.productForm = document.querySelector(".js-product-main-form")),
        (this.productSelectors = this.productForm.querySelector(
          ".js-product-main__option-selectors"
        )),
        (this.productATC = this.productForm.querySelector(
          ".js-product-main__atc"
        )),
        (this.variantTitle = this.querySelector(
          ".js-product-sticky-atc__title"
        )),
        (this.variantImage = this.querySelector(
          ".js-product-sticky-atc__image"
        )),
        (this.ATCBtn = this.querySelector(".js-product-sticky-atc__btn")),
        (this.ATCPrice = document.querySelector(
          ".js-product-sticky-atc__price"
        )),
        this.productSelectors &&
          this.productSelectors.subscribe(() => {
            this.onProductVariantChange(this.productSelectors.selectedVariant);
          }),
        this.ATCBtn.addEventListener(
          "click",
          (e) => (e.preventDefault(), this.productForm.addToCart(), !1)
        );
      ["resize", "scroll"].forEach((e) =>
        window.addEventListener(e, () => this.toggleStickyAtc())
      ),
        this.toggleStickyAtc();
    }
    onProductVariantChange(e) {
      const t = e.compare_at_price && e.compare_at_price != e.price;
      (this.ATCPrice.innerHTML = `<span>\n                               ${this.ShopifyUtils.formatMoney(
        e.price
      )}\n                               </span>\n                               ${
        t
          ? `<span class="t-r cell-l d-block"><strike>${this.ShopifyUtils.formatMoney(
              e.compare_at_price
            )}</strike></span>`
          : ""
      }`),
        (this.ATCBtn.disabled = !e.available),
        (this.variantTitle.innerHTML =
          "Default Title" == e.title ? "" : e.title);
        if (e.featured_image) {
          const { src: s } = e.featured_image;
          s && (this.variantImage.src = `${s}?width=128`);
        } else {
          this.variantImage.src = "";
        }
    }
    toggleStickyAtc() {
      const { top: e } = this.productATC.getBoundingClientRect(),
        t =
          window.innerWidth > window.globalDesign.breakPoints.tablet
            ? "-100%"
            : "100%";
      e < 0 && !this.visible
        ? ((this.visible = !0),
          (this.style.display = "flex"),
          (this.animate(
            [
              { opacity: 0, transform: `translateY(${t})` },
              { opacity: 1, transform: "translateY(0%)" },
            ],
            300
          ).onfinish = (e) => {
            (this.style.opacity = 1),
              (this.style.transform = "translateY(0px)");
          }))
        : e > 0 &&
          this.visible &&
          ((this.visible = !1),
          (this.animate(
            [
              { opacity: 1, transform: "translateY(0%)" },
              { opacity: 0, transform: `translateY(${t})` },
            ],
            300
          ).onfinish = (e) => {
            (this.style.opacity = 0),
              (this.style.transform = `translateY(${t})`),
              (this.style.display = "none");
          }));
    }
  }
  function i(e) {
    return (
      null !== e &&
      "object" == typeof e &&
      "constructor" in e &&
      e.constructor === Object
    );
  }
  function r(e = {}, t = {}) {
    Object.keys(t).forEach((s) => {
      void 0 === e[s]
        ? (e[s] = t[s])
        : i(t[s]) && i(e[s]) && Object.keys(t[s]).length > 0 && r(e[s], t[s]);
    });
  }
  customElements.define("product-sticky-atc", ProductStickyAtc);
  const n = {
    body: {},
    addEventListener() {},
    removeEventListener() {},
    activeElement: { blur() {}, nodeName: "" },
    querySelector: () => null,
    querySelectorAll: () => [],
    getElementById: () => null,
    createEvent: () => ({ initEvent() {} }),
    createElement: () => ({
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName: () => [],
    }),
    createElementNS: () => ({}),
    importNode: () => null,
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
  };
  function a() {
    const e = "undefined" != typeof document ? document : {};
    return r(e, n), e;
  }
  const o = {
    document: n,
    navigator: { userAgent: "" },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
    history: { replaceState() {}, pushState() {}, go() {}, back() {} },
    CustomEvent: function () {
      return this;
    },
    addEventListener() {},
    removeEventListener() {},
    getComputedStyle: () => ({ getPropertyValue: () => "" }),
    Image() {},
    Date() {},
    screen: {},
    setTimeout() {},
    clearTimeout() {},
    matchMedia: () => ({}),
    requestAnimationFrame: (e) =>
      "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
    cancelAnimationFrame(e) {
      "undefined" != typeof setTimeout && clearTimeout(e);
    },
  };
  function l() {
    const e = "undefined" != typeof window ? window : {};
    return r(e, o), e;
  }
  function d(e, t = 0) {
    return setTimeout(e, t);
  }
  function c() {
    return Date.now();
  }
  function p(e, t = "x") {
    const s = l();
    let i, r, n;
    const a = (function (e) {
      const t = l();
      let s;
      return (
        t.getComputedStyle && (s = t.getComputedStyle(e, null)),
        !s && e.currentStyle && (s = e.currentStyle),
        s || (s = e.style),
        s
      );
    })(e);
    return (
      s.WebKitCSSMatrix
        ? ((r = a.transform || a.webkitTransform),
          r.split(",").length > 6 &&
            (r = r
              .split(", ")
              .map((e) => e.replace(",", "."))
              .join(", ")),
          (n = new s.WebKitCSSMatrix("none" === r ? "" : r)))
        : ((n =
            a.MozTransform ||
            a.OTransform ||
            a.MsTransform ||
            a.msTransform ||
            a.transform ||
            a
              .getPropertyValue("transform")
              .replace("translate(", "matrix(1, 0, 0, 1,")),
          (i = n.toString().split(","))),
      "x" === t &&
        (r = s.WebKitCSSMatrix
          ? n.m41
          : 16 === i.length
          ? parseFloat(i[12])
          : parseFloat(i[4])),
      "y" === t &&
        (r = s.WebKitCSSMatrix
          ? n.m42
          : 16 === i.length
          ? parseFloat(i[13])
          : parseFloat(i[5])),
      r || 0
    );
  }
  function u(e) {
    return (
      "object" == typeof e &&
      null !== e &&
      e.constructor &&
      "Object" === Object.prototype.toString.call(e).slice(8, -1)
    );
  }
  function h(...e) {
    const t = Object(e[0]),
      s = ["__proto__", "constructor", "prototype"];
    for (let r = 1; r < e.length; r += 1) {
      const n = e[r];
      if (
        null != n &&
        ((i = n),
        !("undefined" != typeof window && void 0 !== window.HTMLElement
          ? i instanceof HTMLElement
          : i && (1 === i.nodeType || 11 === i.nodeType)))
      ) {
        const e = Object.keys(Object(n)).filter((e) => s.indexOf(e) < 0);
        for (let s = 0, i = e.length; s < i; s += 1) {
          const i = e[s],
            r = Object.getOwnPropertyDescriptor(n, i);
          void 0 !== r &&
            r.enumerable &&
            (u(t[i]) && u(n[i])
              ? n[i].__swiper__
                ? (t[i] = n[i])
                : h(t[i], n[i])
              : !u(t[i]) && u(n[i])
              ? ((t[i] = {}), n[i].__swiper__ ? (t[i] = n[i]) : h(t[i], n[i]))
              : (t[i] = n[i]));
        }
      }
    }
    var i;
    return t;
  }
  function m(e, t, s) {
    e.style.setProperty(t, s);
  }
  function f({ swiper: e, targetPosition: t, side: s }) {
    const i = l(),
      r = -e.translate;
    let n,
      a = null;
    const o = e.params.speed;
    (e.wrapperEl.style.scrollSnapType = "none"),
      i.cancelAnimationFrame(e.cssModeFrameID);
    const d = t > r ? "next" : "prev",
      c = (e, t) => ("next" === d && e >= t) || ("prev" === d && e <= t),
      p = () => {
        (n = new Date().getTime()), null === a && (a = n);
        const l = Math.max(Math.min((n - a) / o, 1), 0),
          d = 0.5 - Math.cos(l * Math.PI) / 2;
        let u = r + d * (t - r);
        if ((c(u, t) && (u = t), e.wrapperEl.scrollTo({ [s]: u }), c(u, t)))
          return (
            (e.wrapperEl.style.overflow = "hidden"),
            (e.wrapperEl.style.scrollSnapType = ""),
            setTimeout(() => {
              (e.wrapperEl.style.overflow = ""),
                e.wrapperEl.scrollTo({ [s]: u });
            }),
            void i.cancelAnimationFrame(e.cssModeFrameID)
          );
        e.cssModeFrameID = i.requestAnimationFrame(p);
      };
    p();
  }
  function v(e, t = "") {
    return [...e.children].filter((e) => e.matches(t));
  }
  function g(e, t) {
    return l().getComputedStyle(e, null).getPropertyValue(t);
  }
  function w(e) {
    let t,
      s = e;
    if (s) {
      for (t = 0; null !== (s = s.previousSibling); )
        1 === s.nodeType && (t += 1);
      return t;
    }
  }
  function b(e, t, s) {
    const i = l();
    return s
      ? e["width" === t ? "offsetWidth" : "offsetHeight"] +
          parseFloat(
            i
              .getComputedStyle(e, null)
              .getPropertyValue("width" === t ? "margin-right" : "margin-top")
          ) +
          parseFloat(
            i
              .getComputedStyle(e, null)
              .getPropertyValue("width" === t ? "margin-left" : "margin-bottom")
          )
      : e.offsetWidth;
  }
  let S, T, y;
  function x() {
    return (
      S ||
        (S = (function () {
          const e = l(),
            t = a();
          return {
            smoothScroll:
              t.documentElement &&
              t.documentElement.style &&
              "scrollBehavior" in t.documentElement.style,
            touch: !!(
              "ontouchstart" in e ||
              (e.DocumentTouch && t instanceof e.DocumentTouch)
            ),
          };
        })()),
      S
    );
  }
  function C(e = {}) {
    return (
      T ||
        (T = (function ({ userAgent: e } = {}) {
          const t = x(),
            s = l(),
            i = s.navigator.platform,
            r = e || s.navigator.userAgent,
            n = { ios: !1, android: !1 },
            a = s.screen.width,
            o = s.screen.height,
            d = r.match(/(Android);?[\s\/]+([\d.]+)?/);
          let c = r.match(/(iPad).*OS\s([\d_]+)/);
          const p = r.match(/(iPod)(.*OS\s([\d_]+))?/),
            u = !c && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
            h = "Win32" === i;
          let m = "MacIntel" === i;
          return (
            !c &&
              m &&
              t.touch &&
              [
                "1024x1366",
                "1366x1024",
                "834x1194",
                "1194x834",
                "834x1112",
                "1112x834",
                "768x1024",
                "1024x768",
                "820x1180",
                "1180x820",
                "810x1080",
                "1080x810",
              ].indexOf(`${a}x${o}`) >= 0 &&
              ((c = r.match(/(Version)\/([\d.]+)/)),
              c || (c = [0, 1, "13_0_0"]),
              (m = !1)),
            d && !h && ((n.os = "android"), (n.android = !0)),
            (c || u || p) && ((n.os = "ios"), (n.ios = !0)),
            n
          );
        })(e)),
      T
    );
  }
  function E() {
    return (
      y ||
        (y = (function () {
          const e = l();
          let t = !1;
          function s() {
            const t = e.navigator.userAgent.toLowerCase();
            return (
              t.indexOf("safari") >= 0 &&
              t.indexOf("chrome") < 0 &&
              t.indexOf("android") < 0
            );
          }
          if (s()) {
            const s = String(e.navigator.userAgent);
            if (s.includes("Version/")) {
              const [e, i] = s
                .split("Version/")[1]
                .split(" ")[0]
                .split(".")
                .map((e) => Number(e));
              t = e < 16 || (16 === e && i < 2);
            }
          }
          return {
            isSafari: t || s(),
            needPerspectiveFix: t,
            isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
              e.navigator.userAgent
            ),
          };
        })()),
      y
    );
  }
  const M = {
    on(e, t, s) {
      const i = this;
      if (!i.eventsListeners || i.destroyed) return i;
      if ("function" != typeof t) return i;
      const r = s ? "unshift" : "push";
      return (
        e.split(" ").forEach((e) => {
          i.eventsListeners[e] || (i.eventsListeners[e] = []),
            i.eventsListeners[e][r](t);
        }),
        i
      );
    },
    once(e, t, s) {
      const i = this;
      if (!i.eventsListeners || i.destroyed) return i;
      if ("function" != typeof t) return i;
      function r(...s) {
        i.off(e, r), r.__emitterProxy && delete r.__emitterProxy, t.apply(i, s);
      }
      return (r.__emitterProxy = t), i.on(e, r, s);
    },
    onAny(e, t) {
      const s = this;
      if (!s.eventsListeners || s.destroyed) return s;
      if ("function" != typeof e) return s;
      const i = t ? "unshift" : "push";
      return (
        s.eventsAnyListeners.indexOf(e) < 0 && s.eventsAnyListeners[i](e), s
      );
    },
    offAny(e) {
      const t = this;
      if (!t.eventsListeners || t.destroyed) return t;
      if (!t.eventsAnyListeners) return t;
      const s = t.eventsAnyListeners.indexOf(e);
      return s >= 0 && t.eventsAnyListeners.splice(s, 1), t;
    },
    off(e, t) {
      const s = this;
      return !s.eventsListeners || s.destroyed
        ? s
        : s.eventsListeners
        ? (e.split(" ").forEach((e) => {
            void 0 === t
              ? (s.eventsListeners[e] = [])
              : s.eventsListeners[e] &&
                s.eventsListeners[e].forEach((i, r) => {
                  (i === t || (i.__emitterProxy && i.__emitterProxy === t)) &&
                    s.eventsListeners[e].splice(r, 1);
                });
          }),
          s)
        : s;
    },
    emit(...e) {
      const t = this;
      if (!t.eventsListeners || t.destroyed) return t;
      if (!t.eventsListeners) return t;
      let s, i, r;
      "string" == typeof e[0] || Array.isArray(e[0])
        ? ((s = e[0]), (i = e.slice(1, e.length)), (r = t))
        : ((s = e[0].events), (i = e[0].data), (r = e[0].context || t)),
        i.unshift(r);
      return (
        (Array.isArray(s) ? s : s.split(" ")).forEach((e) => {
          t.eventsAnyListeners &&
            t.eventsAnyListeners.length &&
            t.eventsAnyListeners.forEach((t) => {
              t.apply(r, [e, ...i]);
            }),
            t.eventsListeners &&
              t.eventsListeners[e] &&
              t.eventsListeners[e].forEach((e) => {
                e.apply(r, i);
              });
        }),
        t
      );
    },
  };
  const P = (e, t) => {
      if (!e || e.destroyed || !e.params) return;
      const s = t.closest(
        e.isElement ? "swiper-slide" : `.${e.params.slideClass}`
      );
      if (s) {
        const t = s.querySelector(`.${e.params.lazyPreloaderClass}`);
        t && t.remove();
      }
    },
    k = (e, t) => {
      if (!e.slides[t]) return;
      const s = e.slides[t].querySelector('[loading="lazy"]');
      s && s.removeAttribute("loading");
    },
    O = (e) => {
      if (!e || e.destroyed || !e.params) return;
      let t = e.params.lazyPreloadPrevNext;
      const s = e.slides.length;
      if (!s || !t || t < 0) return;
      t = Math.min(t, s);
      const i =
          "auto" === e.params.slidesPerView
            ? e.slidesPerViewDynamic()
            : Math.ceil(e.params.slidesPerView),
        r = e.activeIndex;
      if (e.params.grid && e.params.grid.rows > 1) {
        const s = r,
          n = [s - t];
        return (
          n.push(...Array.from({ length: t }).map((e, t) => s + i + t)),
          void e.slides.forEach((t, s) => {
            n.includes(t.column) && k(e, s);
          })
        );
      }
      const n = r + i - 1;
      if (e.params.rewind || e.params.loop)
        for (let i = r - t; i <= n + t; i += 1) {
          const t = ((i % s) + s) % s;
          (t < r || t > n) && k(e, t);
        }
      else
        for (let i = Math.max(r - t, 0); i <= Math.min(n + t, s - 1); i += 1)
          i !== r && (i > n || i < r) && k(e, i);
    };
  const L = {
    updateSize: function () {
      const e = this;
      let t, s;
      const i = e.el;
      (t =
        void 0 !== e.params.width && null !== e.params.width
          ? e.params.width
          : i.clientWidth),
        (s =
          void 0 !== e.params.height && null !== e.params.height
            ? e.params.height
            : i.clientHeight),
        (0 === t && e.isHorizontal()) ||
          (0 === s && e.isVertical()) ||
          ((t =
            t -
            parseInt(g(i, "padding-left") || 0, 10) -
            parseInt(g(i, "padding-right") || 0, 10)),
          (s =
            s -
            parseInt(g(i, "padding-top") || 0, 10) -
            parseInt(g(i, "padding-bottom") || 0, 10)),
          Number.isNaN(t) && (t = 0),
          Number.isNaN(s) && (s = 0),
          Object.assign(e, {
            width: t,
            height: s,
            size: e.isHorizontal() ? t : s,
          }));
    },
    updateSlides: function () {
      const e = this;
      function t(t) {
        return e.isHorizontal()
          ? t
          : {
              width: "height",
              "margin-top": "margin-left",
              "margin-bottom ": "margin-right",
              "margin-left": "margin-top",
              "margin-right": "margin-bottom",
              "padding-left": "padding-top",
              "padding-right": "padding-bottom",
              marginRight: "marginBottom",
            }[t];
      }
      function s(e, s) {
        return parseFloat(e.getPropertyValue(t(s)) || 0);
      }
      const i = e.params,
        {
          wrapperEl: r,
          slidesEl: n,
          size: a,
          rtlTranslate: o,
          wrongRTL: l,
        } = e,
        d = e.virtual && i.virtual.enabled,
        c = d ? e.virtual.slides.length : e.slides.length,
        p = v(n, `.${e.params.slideClass}, swiper-slide`),
        u = d ? e.virtual.slides.length : p.length;
      let h = [];
      const f = [],
        w = [];
      let S = i.slidesOffsetBefore;
      "function" == typeof S && (S = i.slidesOffsetBefore.call(e));
      let T = i.slidesOffsetAfter;
      "function" == typeof T && (T = i.slidesOffsetAfter.call(e));
      const y = e.snapGrid.length,
        x = e.slidesGrid.length;
      let C = i.spaceBetween,
        E = -S,
        M = 0,
        P = 0;
      if (void 0 === a) return;
      "string" == typeof C && C.indexOf("%") >= 0
        ? (C = (parseFloat(C.replace("%", "")) / 100) * a)
        : "string" == typeof C && (C = parseFloat(C)),
        (e.virtualSize = -C),
        p.forEach((e) => {
          o ? (e.style.marginLeft = "") : (e.style.marginRight = ""),
            (e.style.marginBottom = ""),
            (e.style.marginTop = "");
        }),
        i.centeredSlides &&
          i.cssMode &&
          (m(r, "--swiper-centered-offset-before", ""),
          m(r, "--swiper-centered-offset-after", ""));
      const k = i.grid && i.grid.rows > 1 && e.grid;
      let O;
      k && e.grid.initSlides(u);
      const L =
        "auto" === i.slidesPerView &&
        i.breakpoints &&
        Object.keys(i.breakpoints).filter(
          (e) => void 0 !== i.breakpoints[e].slidesPerView
        ).length > 0;
      for (let r = 0; r < u; r += 1) {
        let n;
        if (
          ((O = 0),
          p[r] && (n = p[r]),
          k && e.grid.updateSlide(r, n, u, t),
          !p[r] || "none" !== g(n, "display"))
        ) {
          if ("auto" === i.slidesPerView) {
            L && (p[r].style[t("width")] = "");
            const a = getComputedStyle(n),
              o = n.style.transform,
              l = n.style.webkitTransform;
            if (
              (o && (n.style.transform = "none"),
              l && (n.style.webkitTransform = "none"),
              i.roundLengths)
            )
              O = e.isHorizontal() ? b(n, "width", !0) : b(n, "height", !0);
            else {
              const e = s(a, "width"),
                t = s(a, "padding-left"),
                i = s(a, "padding-right"),
                r = s(a, "margin-left"),
                o = s(a, "margin-right"),
                l = a.getPropertyValue("box-sizing");
              if (l && "border-box" === l) O = e + r + o;
              else {
                const { clientWidth: s, offsetWidth: a } = n;
                O = e + t + i + r + o + (a - s);
              }
            }
            o && (n.style.transform = o),
              l && (n.style.webkitTransform = l),
              i.roundLengths && (O = Math.floor(O));
          } else
            (O = (a - (i.slidesPerView - 1) * C) / i.slidesPerView),
              i.roundLengths && (O = Math.floor(O)),
              p[r] && (p[r].style[t("width")] = `${O}px`);
          p[r] && (p[r].swiperSlideSize = O),
            w.push(O),
            i.centeredSlides
              ? ((E = E + O / 2 + M / 2 + C),
                0 === M && 0 !== r && (E = E - a / 2 - C),
                0 === r && (E = E - a / 2 - C),
                Math.abs(E) < 0.001 && (E = 0),
                i.roundLengths && (E = Math.floor(E)),
                P % i.slidesPerGroup == 0 && h.push(E),
                f.push(E))
              : (i.roundLengths && (E = Math.floor(E)),
                (P - Math.min(e.params.slidesPerGroupSkip, P)) %
                  e.params.slidesPerGroup ==
                  0 && h.push(E),
                f.push(E),
                (E = E + O + C)),
            (e.virtualSize += O + C),
            (M = O),
            (P += 1);
        }
      }
      if (
        ((e.virtualSize = Math.max(e.virtualSize, a) + T),
        o &&
          l &&
          ("slide" === i.effect || "coverflow" === i.effect) &&
          (r.style.width = `${e.virtualSize + C}px`),
        i.setWrapperSize && (r.style[t("width")] = `${e.virtualSize + C}px`),
        k && e.grid.updateWrapperSize(O, h, t),
        !i.centeredSlides)
      ) {
        const t = [];
        for (let s = 0; s < h.length; s += 1) {
          let r = h[s];
          i.roundLengths && (r = Math.floor(r)),
            h[s] <= e.virtualSize - a && t.push(r);
        }
        (h = t),
          Math.floor(e.virtualSize - a) - Math.floor(h[h.length - 1]) > 1 &&
            h.push(e.virtualSize - a);
      }
      if (d && i.loop) {
        const t = w[0] + C;
        if (i.slidesPerGroup > 1) {
          const s = Math.ceil(
              (e.virtual.slidesBefore + e.virtual.slidesAfter) /
                i.slidesPerGroup
            ),
            r = t * i.slidesPerGroup;
          for (let e = 0; e < s; e += 1) h.push(h[h.length - 1] + r);
        }
        for (
          let s = 0;
          s < e.virtual.slidesBefore + e.virtual.slidesAfter;
          s += 1
        )
          1 === i.slidesPerGroup && h.push(h[h.length - 1] + t),
            f.push(f[f.length - 1] + t),
            (e.virtualSize += t);
      }
      if ((0 === h.length && (h = [0]), 0 !== C)) {
        const s = e.isHorizontal() && o ? "marginLeft" : t("marginRight");
        p.filter(
          (e, t) => !(i.cssMode && !i.loop) || t !== p.length - 1
        ).forEach((e) => {
          e.style[s] = `${C}px`;
        });
      }
      if (i.centeredSlides && i.centeredSlidesBounds) {
        let e = 0;
        w.forEach((t) => {
          e += t + (C || 0);
        }),
          (e -= C);
        const t = e - a;
        h = h.map((e) => (e <= 0 ? -S : e > t ? t + T : e));
      }
      if (i.centerInsufficientSlides) {
        let e = 0;
        if (
          (w.forEach((t) => {
            e += t + (C || 0);
          }),
          (e -= C),
          e < a)
        ) {
          const t = (a - e) / 2;
          h.forEach((e, s) => {
            h[s] = e - t;
          }),
            f.forEach((e, s) => {
              f[s] = e + t;
            });
        }
      }
      if (
        (Object.assign(e, {
          slides: p,
          snapGrid: h,
          slidesGrid: f,
          slidesSizesGrid: w,
        }),
        i.centeredSlides && i.cssMode && !i.centeredSlidesBounds)
      ) {
        m(r, "--swiper-centered-offset-before", -h[0] + "px"),
          m(
            r,
            "--swiper-centered-offset-after",
            e.size / 2 - w[w.length - 1] / 2 + "px"
          );
        const t = -e.snapGrid[0],
          s = -e.slidesGrid[0];
        (e.snapGrid = e.snapGrid.map((e) => e + t)),
          (e.slidesGrid = e.slidesGrid.map((e) => e + s));
      }
      if (
        (u !== c && e.emit("slidesLengthChange"),
        h.length !== y &&
          (e.params.watchOverflow && e.checkOverflow(),
          e.emit("snapGridLengthChange")),
        f.length !== x && e.emit("slidesGridLengthChange"),
        i.watchSlidesProgress && e.updateSlidesOffset(),
        !(d || i.cssMode || ("slide" !== i.effect && "fade" !== i.effect)))
      ) {
        const t = `${i.containerModifierClass}backface-hidden`,
          s = e.el.classList.contains(t);
        u <= i.maxBackfaceHiddenSlides
          ? s || e.el.classList.add(t)
          : s && e.el.classList.remove(t);
      }
    },
    updateAutoHeight: function (e) {
      const t = this,
        s = [],
        i = t.virtual && t.params.virtual.enabled;
      let r,
        n = 0;
      "number" == typeof e
        ? t.setTransition(e)
        : !0 === e && t.setTransition(t.params.speed);
      const a = (e) => (i ? t.slides[t.getSlideIndexByData(e)] : t.slides[e]);
      if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
        if (t.params.centeredSlides)
          (t.visibleSlides || []).forEach((e) => {
            s.push(e);
          });
        else
          for (r = 0; r < Math.ceil(t.params.slidesPerView); r += 1) {
            const e = t.activeIndex + r;
            if (e > t.slides.length && !i) break;
            s.push(a(e));
          }
      else s.push(a(t.activeIndex));
      for (r = 0; r < s.length; r += 1)
        if (void 0 !== s[r]) {
          const e = s[r].offsetHeight;
          n = e > n ? e : n;
        }
      (n || 0 === n) && (t.wrapperEl.style.height = `${n}px`);
    },
    updateSlidesOffset: function () {
      const e = this,
        t = e.slides,
        s = e.isElement
          ? e.isHorizontal()
            ? e.wrapperEl.offsetLeft
            : e.wrapperEl.offsetTop
          : 0;
      for (let i = 0; i < t.length; i += 1)
        t[i].swiperSlideOffset =
          (e.isHorizontal() ? t[i].offsetLeft : t[i].offsetTop) -
          s -
          e.cssOverflowAdjustment();
    },
    updateSlidesProgress: function (e = (this && this.translate) || 0) {
      const t = this,
        s = t.params,
        { slides: i, rtlTranslate: r, snapGrid: n } = t;
      if (0 === i.length) return;
      void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
      let a = -e;
      r && (a = e),
        i.forEach((e) => {
          e.classList.remove(s.slideVisibleClass);
        }),
        (t.visibleSlidesIndexes = []),
        (t.visibleSlides = []);
      let o = s.spaceBetween;
      "string" == typeof o && o.indexOf("%") >= 0
        ? (o = (parseFloat(o.replace("%", "")) / 100) * t.size)
        : "string" == typeof o && (o = parseFloat(o));
      for (let e = 0; e < i.length; e += 1) {
        const l = i[e];
        let d = l.swiperSlideOffset;
        s.cssMode && s.centeredSlides && (d -= i[0].swiperSlideOffset);
        const c =
            (a + (s.centeredSlides ? t.minTranslate() : 0) - d) /
            (l.swiperSlideSize + o),
          p =
            (a - n[0] + (s.centeredSlides ? t.minTranslate() : 0) - d) /
            (l.swiperSlideSize + o),
          u = -(a - d),
          h = u + t.slidesSizesGrid[e];
        ((u >= 0 && u < t.size - 1) ||
          (h > 1 && h <= t.size) ||
          (u <= 0 && h >= t.size)) &&
          (t.visibleSlides.push(l),
          t.visibleSlidesIndexes.push(e),
          i[e].classList.add(s.slideVisibleClass)),
          (l.progress = r ? -c : c),
          (l.originalProgress = r ? -p : p);
      }
    },
    updateProgress: function (e) {
      const t = this;
      if (void 0 === e) {
        const s = t.rtlTranslate ? -1 : 1;
        e = (t && t.translate && t.translate * s) || 0;
      }
      const s = t.params,
        i = t.maxTranslate() - t.minTranslate();
      let { progress: r, isBeginning: n, isEnd: a, progressLoop: o } = t;
      const l = n,
        d = a;
      if (0 === i) (r = 0), (n = !0), (a = !0);
      else {
        r = (e - t.minTranslate()) / i;
        const s = Math.abs(e - t.minTranslate()) < 1,
          o = Math.abs(e - t.maxTranslate()) < 1;
        (n = s || r <= 0), (a = o || r >= 1), s && (r = 0), o && (r = 1);
      }
      if (s.loop) {
        const s = t.getSlideIndexByData(0),
          i = t.getSlideIndexByData(t.slides.length - 1),
          r = t.slidesGrid[s],
          n = t.slidesGrid[i],
          a = t.slidesGrid[t.slidesGrid.length - 1],
          l = Math.abs(e);
        (o = l >= r ? (l - r) / a : (l + a - n) / a), o > 1 && (o -= 1);
      }
      Object.assign(t, {
        progress: r,
        progressLoop: o,
        isBeginning: n,
        isEnd: a,
      }),
        (s.watchSlidesProgress || (s.centeredSlides && s.autoHeight)) &&
          t.updateSlidesProgress(e),
        n && !l && t.emit("reachBeginning toEdge"),
        a && !d && t.emit("reachEnd toEdge"),
        ((l && !n) || (d && !a)) && t.emit("fromEdge"),
        t.emit("progress", r);
    },
    updateSlidesClasses: function () {
      const e = this,
        { slides: t, params: s, slidesEl: i, activeIndex: r } = e,
        n = e.virtual && s.virtual.enabled,
        a = (e) => v(i, `.${s.slideClass}${e}, swiper-slide${e}`)[0];
      let o;
      if (
        (t.forEach((e) => {
          e.classList.remove(
            s.slideActiveClass,
            s.slideNextClass,
            s.slidePrevClass
          );
        }),
        n)
      )
        if (s.loop) {
          let t = r - e.virtual.slidesBefore;
          t < 0 && (t = e.virtual.slides.length + t),
            t >= e.virtual.slides.length && (t -= e.virtual.slides.length),
            (o = a(`[data-swiper-slide-index="${t}"]`));
        } else o = a(`[data-swiper-slide-index="${r}"]`);
      else o = t[r];
      if (o) {
        o.classList.add(s.slideActiveClass);
        let e = (function (e, t) {
          const s = [];
          for (; e.nextElementSibling; ) {
            const i = e.nextElementSibling;
            t ? i.matches(t) && s.push(i) : s.push(i), (e = i);
          }
          return s;
        })(o, `.${s.slideClass}, swiper-slide`)[0];
        s.loop && !e && (e = t[0]), e && e.classList.add(s.slideNextClass);
        let i = (function (e, t) {
          const s = [];
          for (; e.previousElementSibling; ) {
            const i = e.previousElementSibling;
            t ? i.matches(t) && s.push(i) : s.push(i), (e = i);
          }
          return s;
        })(o, `.${s.slideClass}, swiper-slide`)[0];
        s.loop && 0 === !i && (i = t[t.length - 1]),
          i && i.classList.add(s.slidePrevClass);
      }
      e.emitSlidesClasses();
    },
    updateActiveIndex: function (e) {
      const t = this,
        s = t.rtlTranslate ? t.translate : -t.translate,
        {
          snapGrid: i,
          params: r,
          activeIndex: n,
          realIndex: a,
          snapIndex: o,
        } = t;
      let l,
        d = e;
      const c = (e) => {
        let s = e - t.virtual.slidesBefore;
        return (
          s < 0 && (s = t.virtual.slides.length + s),
          s >= t.virtual.slides.length && (s -= t.virtual.slides.length),
          s
        );
      };
      if (
        (void 0 === d &&
          (d = (function (e) {
            const { slidesGrid: t, params: s } = e,
              i = e.rtlTranslate ? e.translate : -e.translate;
            let r;
            for (let e = 0; e < t.length; e += 1)
              void 0 !== t[e + 1]
                ? i >= t[e] && i < t[e + 1] - (t[e + 1] - t[e]) / 2
                  ? (r = e)
                  : i >= t[e] && i < t[e + 1] && (r = e + 1)
                : i >= t[e] && (r = e);
            return (
              s.normalizeSlideIndex && (r < 0 || void 0 === r) && (r = 0), r
            );
          })(t)),
        i.indexOf(s) >= 0)
      )
        l = i.indexOf(s);
      else {
        const e = Math.min(r.slidesPerGroupSkip, d);
        l = e + Math.floor((d - e) / r.slidesPerGroup);
      }
      if ((l >= i.length && (l = i.length - 1), d === n))
        return (
          l !== o && ((t.snapIndex = l), t.emit("snapIndexChange")),
          void (
            t.params.loop &&
            t.virtual &&
            t.params.virtual.enabled &&
            (t.realIndex = c(d))
          )
        );
      let p;
      (p =
        t.virtual && r.virtual.enabled && r.loop
          ? c(d)
          : t.slides[d]
          ? parseInt(
              t.slides[d].getAttribute("data-swiper-slide-index") || d,
              10
            )
          : d),
        Object.assign(t, {
          previousSnapIndex: o,
          snapIndex: l,
          previousRealIndex: a,
          realIndex: p,
          previousIndex: n,
          activeIndex: d,
        }),
        t.initialized && O(t),
        t.emit("activeIndexChange"),
        t.emit("snapIndexChange"),
        a !== p && t.emit("realIndexChange"),
        (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
    },
    updateClickedSlide: function (e) {
      const t = this,
        s = t.params,
        i = e.closest(`.${s.slideClass}, swiper-slide`);
      let r,
        n = !1;
      if (i)
        for (let e = 0; e < t.slides.length; e += 1)
          if (t.slides[e] === i) {
            (n = !0), (r = e);
            break;
          }
      if (!i || !n)
        return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
      (t.clickedSlide = i),
        t.virtual && t.params.virtual.enabled
          ? (t.clickedIndex = parseInt(
              i.getAttribute("data-swiper-slide-index"),
              10
            ))
          : (t.clickedIndex = r),
        s.slideToClickedSlide &&
          void 0 !== t.clickedIndex &&
          t.clickedIndex !== t.activeIndex &&
          t.slideToClickedSlide();
    },
  };
  const I = {
    getTranslate: function (e = this.isHorizontal() ? "x" : "y") {
      const { params: t, rtlTranslate: s, translate: i, wrapperEl: r } = this;
      if (t.virtualTranslate) return s ? -i : i;
      if (t.cssMode) return i;
      let n = p(r, e);
      return (n += this.cssOverflowAdjustment()), s && (n = -n), n || 0;
    },
    setTranslate: function (e, t) {
      const s = this,
        { rtlTranslate: i, params: r, wrapperEl: n, progress: a } = s;
      let o,
        l = 0,
        d = 0;
      s.isHorizontal() ? (l = i ? -e : e) : (d = e),
        r.roundLengths && ((l = Math.floor(l)), (d = Math.floor(d))),
        (s.previousTranslate = s.translate),
        (s.translate = s.isHorizontal() ? l : d),
        r.cssMode
          ? (n[s.isHorizontal() ? "scrollLeft" : "scrollTop"] = s.isHorizontal()
              ? -l
              : -d)
          : r.virtualTranslate ||
            (s.isHorizontal()
              ? (l -= s.cssOverflowAdjustment())
              : (d -= s.cssOverflowAdjustment()),
            (n.style.transform = `translate3d(${l}px, ${d}px, 0px)`));
      const c = s.maxTranslate() - s.minTranslate();
      (o = 0 === c ? 0 : (e - s.minTranslate()) / c),
        o !== a && s.updateProgress(e),
        s.emit("setTranslate", s.translate, t);
    },
    minTranslate: function () {
      return -this.snapGrid[0];
    },
    maxTranslate: function () {
      return -this.snapGrid[this.snapGrid.length - 1];
    },
    translateTo: function (e = 0, t = this.params.speed, s = !0, i = !0, r) {
      const n = this,
        { params: a, wrapperEl: o } = n;
      if (n.animating && a.preventInteractionOnTransition) return !1;
      const l = n.minTranslate(),
        d = n.maxTranslate();
      let c;
      if (
        ((c = i && e > l ? l : i && e < d ? d : e),
        n.updateProgress(c),
        a.cssMode)
      ) {
        const e = n.isHorizontal();
        if (0 === t) o[e ? "scrollLeft" : "scrollTop"] = -c;
        else {
          if (!n.support.smoothScroll)
            return (
              f({ swiper: n, targetPosition: -c, side: e ? "left" : "top" }), !0
            );
          o.scrollTo({ [e ? "left" : "top"]: -c, behavior: "smooth" });
        }
        return !0;
      }
      return (
        0 === t
          ? (n.setTransition(0),
            n.setTranslate(c),
            s &&
              (n.emit("beforeTransitionStart", t, r), n.emit("transitionEnd")))
          : (n.setTransition(t),
            n.setTranslate(c),
            s &&
              (n.emit("beforeTransitionStart", t, r),
              n.emit("transitionStart")),
            n.animating ||
              ((n.animating = !0),
              n.onTranslateToWrapperTransitionEnd ||
                (n.onTranslateToWrapperTransitionEnd = function (e) {
                  n &&
                    !n.destroyed &&
                    e.target === this &&
                    (n.wrapperEl.removeEventListener(
                      "transitionend",
                      n.onTranslateToWrapperTransitionEnd
                    ),
                    (n.onTranslateToWrapperTransitionEnd = null),
                    delete n.onTranslateToWrapperTransitionEnd,
                    s && n.emit("transitionEnd"));
                }),
              n.wrapperEl.addEventListener(
                "transitionend",
                n.onTranslateToWrapperTransitionEnd
              ))),
        !0
      );
    },
  };
  function _({ swiper: e, runCallbacks: t, direction: s, step: i }) {
    const { activeIndex: r, previousIndex: n } = e;
    let a = s;
    if (
      (a || (a = r > n ? "next" : r < n ? "prev" : "reset"),
      e.emit(`transition${i}`),
      t && r !== n)
    ) {
      if ("reset" === a) return void e.emit(`slideResetTransition${i}`);
      e.emit(`slideChangeTransition${i}`),
        "next" === a
          ? e.emit(`slideNextTransition${i}`)
          : e.emit(`slidePrevTransition${i}`);
    }
  }
  const A = {
    slideTo: function (e = 0, t = this.params.speed, s = !0, i, r) {
      "string" == typeof e && (e = parseInt(e, 10));
      const n = this;
      let a = e;
      a < 0 && (a = 0);
      const {
        params: o,
        snapGrid: l,
        slidesGrid: d,
        previousIndex: c,
        activeIndex: p,
        rtlTranslate: u,
        wrapperEl: h,
        enabled: m,
      } = n;
      if ((n.animating && o.preventInteractionOnTransition) || (!m && !i && !r))
        return !1;
      const v = Math.min(n.params.slidesPerGroupSkip, a);
      let g = v + Math.floor((a - v) / n.params.slidesPerGroup);
      g >= l.length && (g = l.length - 1);
      const w = -l[g];
      if (o.normalizeSlideIndex)
        for (let e = 0; e < d.length; e += 1) {
          const t = -Math.floor(100 * w),
            s = Math.floor(100 * d[e]),
            i = Math.floor(100 * d[e + 1]);
          void 0 !== d[e + 1]
            ? t >= s && t < i - (i - s) / 2
              ? (a = e)
              : t >= s && t < i && (a = e + 1)
            : t >= s && (a = e);
        }
      if (n.initialized && a !== p) {
        if (
          !n.allowSlideNext &&
          (u
            ? w > n.translate && w > n.minTranslate()
            : w < n.translate && w < n.minTranslate())
        )
          return !1;
        if (
          !n.allowSlidePrev &&
          w > n.translate &&
          w > n.maxTranslate() &&
          (p || 0) !== a
        )
          return !1;
      }
      let b;
      if (
        (a !== (c || 0) && s && n.emit("beforeSlideChangeStart"),
        n.updateProgress(w),
        (b = a > p ? "next" : a < p ? "prev" : "reset"),
        (u && -w === n.translate) || (!u && w === n.translate))
      )
        return (
          n.updateActiveIndex(a),
          o.autoHeight && n.updateAutoHeight(),
          n.updateSlidesClasses(),
          "slide" !== o.effect && n.setTranslate(w),
          "reset" !== b && (n.transitionStart(s, b), n.transitionEnd(s, b)),
          !1
        );
      if (o.cssMode) {
        const e = n.isHorizontal(),
          s = u ? w : -w;
        if (0 === t) {
          const t = n.virtual && n.params.virtual.enabled;
          t &&
            ((n.wrapperEl.style.scrollSnapType = "none"),
            (n._immediateVirtual = !0)),
            t && !n._cssModeVirtualInitialSet && n.params.initialSlide > 0
              ? ((n._cssModeVirtualInitialSet = !0),
                requestAnimationFrame(() => {
                  h[e ? "scrollLeft" : "scrollTop"] = s;
                }))
              : (h[e ? "scrollLeft" : "scrollTop"] = s),
            t &&
              requestAnimationFrame(() => {
                (n.wrapperEl.style.scrollSnapType = ""),
                  (n._immediateVirtual = !1);
              });
        } else {
          if (!n.support.smoothScroll)
            return (
              f({ swiper: n, targetPosition: s, side: e ? "left" : "top" }), !0
            );
          h.scrollTo({ [e ? "left" : "top"]: s, behavior: "smooth" });
        }
        return !0;
      }
      return (
        n.setTransition(t),
        n.setTranslate(w),
        n.updateActiveIndex(a),
        n.updateSlidesClasses(),
        n.emit("beforeTransitionStart", t, i),
        n.transitionStart(s, b),
        0 === t
          ? n.transitionEnd(s, b)
          : n.animating ||
            ((n.animating = !0),
            n.onSlideToWrapperTransitionEnd ||
              (n.onSlideToWrapperTransitionEnd = function (e) {
                n &&
                  !n.destroyed &&
                  e.target === this &&
                  (n.wrapperEl.removeEventListener(
                    "transitionend",
                    n.onSlideToWrapperTransitionEnd
                  ),
                  (n.onSlideToWrapperTransitionEnd = null),
                  delete n.onSlideToWrapperTransitionEnd,
                  n.transitionEnd(s, b));
              }),
            n.wrapperEl.addEventListener(
              "transitionend",
              n.onSlideToWrapperTransitionEnd
            )),
        !0
      );
    },
    slideToLoop: function (e = 0, t = this.params.speed, s = !0, i) {
      if ("string" == typeof e) {
        e = parseInt(e, 10);
      }
      const r = this;
      let n = e;
      return (
        r.params.loop &&
          (r.virtual && r.params.virtual.enabled
            ? (n += r.virtual.slidesBefore)
            : (n = r.getSlideIndexByData(n))),
        r.slideTo(n, t, s, i)
      );
    },
    slideNext: function (e = this.params.speed, t = !0, s) {
      const i = this,
        { enabled: r, params: n, animating: a } = i;
      if (!r) return i;
      let o = n.slidesPerGroup;
      "auto" === n.slidesPerView &&
        1 === n.slidesPerGroup &&
        n.slidesPerGroupAuto &&
        (o = Math.max(i.slidesPerViewDynamic("current", !0), 1));
      const l = i.activeIndex < n.slidesPerGroupSkip ? 1 : o,
        d = i.virtual && n.virtual.enabled;
      if (n.loop) {
        if (a && !d && n.loopPreventsSliding) return !1;
        i.loopFix({ direction: "next" }),
          (i._clientLeft = i.wrapperEl.clientLeft);
      }
      return n.rewind && i.isEnd
        ? i.slideTo(0, e, t, s)
        : i.slideTo(i.activeIndex + l, e, t, s);
    },
    slidePrev: function (e = this.params.speed, t = !0, s) {
      const i = this,
        {
          params: r,
          snapGrid: n,
          slidesGrid: a,
          rtlTranslate: o,
          enabled: l,
          animating: d,
        } = i;
      if (!l) return i;
      const c = i.virtual && r.virtual.enabled;
      if (r.loop) {
        if (d && !c && r.loopPreventsSliding) return !1;
        i.loopFix({ direction: "prev" }),
          (i._clientLeft = i.wrapperEl.clientLeft);
      }
      function p(e) {
        return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
      }
      const u = p(o ? i.translate : -i.translate),
        h = n.map((e) => p(e));
      let m = n[h.indexOf(u) - 1];
      if (void 0 === m && r.cssMode) {
        let e;
        n.forEach((t, s) => {
          u >= t && (e = s);
        }),
          void 0 !== e && (m = n[e > 0 ? e - 1 : e]);
      }
      let f = 0;
      if (
        (void 0 !== m &&
          ((f = a.indexOf(m)),
          f < 0 && (f = i.activeIndex - 1),
          "auto" === r.slidesPerView &&
            1 === r.slidesPerGroup &&
            r.slidesPerGroupAuto &&
            ((f = f - i.slidesPerViewDynamic("previous", !0) + 1),
            (f = Math.max(f, 0)))),
        r.rewind && i.isBeginning)
      ) {
        const r =
          i.params.virtual && i.params.virtual.enabled && i.virtual
            ? i.virtual.slides.length - 1
            : i.slides.length - 1;
        return i.slideTo(r, e, t, s);
      }
      return i.slideTo(f, e, t, s);
    },
    slideReset: function (e = this.params.speed, t = !0, s) {
      return this.slideTo(this.activeIndex, e, t, s);
    },
    slideToClosest: function (e = this.params.speed, t = !0, s, i = 0.5) {
      const r = this;
      let n = r.activeIndex;
      const a = Math.min(r.params.slidesPerGroupSkip, n),
        o = a + Math.floor((n - a) / r.params.slidesPerGroup),
        l = r.rtlTranslate ? r.translate : -r.translate;
      if (l >= r.snapGrid[o]) {
        const e = r.snapGrid[o];
        l - e > (r.snapGrid[o + 1] - e) * i && (n += r.params.slidesPerGroup);
      } else {
        const e = r.snapGrid[o - 1];
        l - e <= (r.snapGrid[o] - e) * i && (n -= r.params.slidesPerGroup);
      }
      return (
        (n = Math.max(n, 0)),
        (n = Math.min(n, r.slidesGrid.length - 1)),
        r.slideTo(n, e, t, s)
      );
    },
    slideToClickedSlide: function () {
      const e = this,
        { params: t, slidesEl: s } = e,
        i =
          "auto" === t.slidesPerView
            ? e.slidesPerViewDynamic()
            : t.slidesPerView;
      let r,
        n = e.clickedIndex;
      const a = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
      if (t.loop) {
        if (e.animating) return;
        (r = parseInt(
          e.clickedSlide.getAttribute("data-swiper-slide-index"),
          10
        )),
          t.centeredSlides
            ? n < e.loopedSlides - i / 2 ||
              n > e.slides.length - e.loopedSlides + i / 2
              ? (e.loopFix(),
                (n = e.getSlideIndex(
                  v(s, `${a}[data-swiper-slide-index="${r}"]`)[0]
                )),
                d(() => {
                  e.slideTo(n);
                }))
              : e.slideTo(n)
            : n > e.slides.length - i
            ? (e.loopFix(),
              (n = e.getSlideIndex(
                v(s, `${a}[data-swiper-slide-index="${r}"]`)[0]
              )),
              d(() => {
                e.slideTo(n);
              }))
            : e.slideTo(n);
      } else e.slideTo(n);
    },
  };
  const z = {
    loopCreate: function (e) {
      const t = this,
        { params: s, slidesEl: i } = t;
      if (!s.loop || (t.virtual && t.params.virtual.enabled)) return;
      v(i, `.${s.slideClass}, swiper-slide`).forEach((e, t) => {
        e.setAttribute("data-swiper-slide-index", t);
      }),
        t.loopFix({
          slideRealIndex: e,
          direction: s.centeredSlides ? void 0 : "next",
        });
    },
    loopFix: function ({
      slideRealIndex: e,
      slideTo: t = !0,
      direction: s,
      setTranslate: i,
      activeSlideIndex: r,
      byController: n,
      byMousewheel: a,
    } = {}) {
      const o = this;
      if (!o.params.loop) return;
      o.emit("beforeLoopFix");
      const {
        slides: l,
        allowSlidePrev: d,
        allowSlideNext: c,
        slidesEl: p,
        params: u,
      } = o;
      if (
        ((o.allowSlidePrev = !0),
        (o.allowSlideNext = !0),
        o.virtual && u.virtual.enabled)
      )
        return (
          t &&
            (u.centeredSlides || 0 !== o.snapIndex
              ? u.centeredSlides && o.snapIndex < u.slidesPerView
                ? o.slideTo(o.virtual.slides.length + o.snapIndex, 0, !1, !0)
                : o.snapIndex === o.snapGrid.length - 1 &&
                  o.slideTo(o.virtual.slidesBefore, 0, !1, !0)
              : o.slideTo(o.virtual.slides.length, 0, !1, !0)),
          (o.allowSlidePrev = d),
          (o.allowSlideNext = c),
          void o.emit("loopFix")
        );
      const h =
        "auto" === u.slidesPerView
          ? o.slidesPerViewDynamic()
          : Math.ceil(parseFloat(u.slidesPerView, 10));
      let m = u.loopedSlides || h;
      m % u.slidesPerGroup != 0 &&
        (m += u.slidesPerGroup - (m % u.slidesPerGroup)),
        (o.loopedSlides = m);
      const f = [],
        v = [];
      let g = o.activeIndex;
      void 0 === r
        ? (r = o.getSlideIndex(
            o.slides.filter((e) => e.classList.contains(u.slideActiveClass))[0]
          ))
        : (g = r);
      const w = "next" === s || !s,
        b = "prev" === s || !s;
      let S = 0,
        T = 0;
      if (r < m) {
        S = Math.max(m - r, u.slidesPerGroup);
        for (let e = 0; e < m - r; e += 1) {
          const t = e - Math.floor(e / l.length) * l.length;
          f.push(l.length - t - 1);
        }
      } else if (r > o.slides.length - 2 * m) {
        T = Math.max(r - (o.slides.length - 2 * m), u.slidesPerGroup);
        for (let e = 0; e < T; e += 1) {
          const t = e - Math.floor(e / l.length) * l.length;
          v.push(t);
        }
      }
      if (
        (b &&
          f.forEach((e) => {
            (o.slides[e].swiperLoopMoveDOM = !0),
              p.prepend(o.slides[e]),
              (o.slides[e].swiperLoopMoveDOM = !1);
          }),
        w &&
          v.forEach((e) => {
            (o.slides[e].swiperLoopMoveDOM = !0),
              p.append(o.slides[e]),
              (o.slides[e].swiperLoopMoveDOM = !1);
          }),
        o.recalcSlides(),
        "auto" === u.slidesPerView && o.updateSlides(),
        u.watchSlidesProgress && o.updateSlidesOffset(),
        t)
      )
        if (f.length > 0 && b)
          if (void 0 === e) {
            const e = o.slidesGrid[g],
              t = o.slidesGrid[g + S] - e;
            a
              ? o.setTranslate(o.translate - t)
              : (o.slideTo(g + S, 0, !1, !0),
                i && (o.touches[o.isHorizontal() ? "startX" : "startY"] += t));
          } else i && o.slideToLoop(e, 0, !1, !0);
        else if (v.length > 0 && w)
          if (void 0 === e) {
            const e = o.slidesGrid[g],
              t = o.slidesGrid[g - T] - e;
            a
              ? o.setTranslate(o.translate - t)
              : (o.slideTo(g - T, 0, !1, !0),
                i && (o.touches[o.isHorizontal() ? "startX" : "startY"] += t));
          } else o.slideToLoop(e, 0, !1, !0);
      if (
        ((o.allowSlidePrev = d),
        (o.allowSlideNext = c),
        o.controller && o.controller.control && !n)
      ) {
        const t = {
          slideRealIndex: e,
          slideTo: !1,
          direction: s,
          setTranslate: i,
          activeSlideIndex: r,
          byController: !0,
        };
        Array.isArray(o.controller.control)
          ? o.controller.control.forEach((e) => {
              !e.destroyed && e.params.loop && e.loopFix(t);
            })
          : o.controller.control instanceof o.constructor &&
            o.controller.control.params.loop &&
            o.controller.control.loopFix(t);
      }
      o.emit("loopFix");
    },
    loopDestroy: function () {
      const e = this,
        { params: t, slidesEl: s } = e;
      if (!t.loop || (e.virtual && e.params.virtual.enabled)) return;
      e.recalcSlides();
      const i = [];
      e.slides.forEach((e) => {
        const t =
          void 0 === e.swiperSlideIndex
            ? 1 * e.getAttribute("data-swiper-slide-index")
            : e.swiperSlideIndex;
        i[t] = e;
      }),
        e.slides.forEach((e) => {
          e.removeAttribute("data-swiper-slide-index");
        }),
        i.forEach((e) => {
          s.append(e);
        }),
        e.recalcSlides(),
        e.slideTo(e.realIndex, 0);
    },
  };
  function G(e) {
    const t = this,
      s = a(),
      i = l(),
      r = t.touchEventsData;
    r.evCache.push(e);
    const { params: n, touches: o, enabled: d } = t;
    if (!d) return;
    if (!n.simulateTouch && "mouse" === e.pointerType) return;
    if (t.animating && n.preventInteractionOnTransition) return;
    !t.animating && n.cssMode && n.loop && t.loopFix();
    let p = e;
    p.originalEvent && (p = p.originalEvent);
    let u = p.target;
    if ("wrapper" === n.touchEventsTarget && !t.wrapperEl.contains(u)) return;
    if ("which" in p && 3 === p.which) return;
    if ("button" in p && p.button > 0) return;
    if (r.isTouched && r.isMoved) return;
    const h = !!n.noSwipingClass && "" !== n.noSwipingClass,
      m = e.composedPath ? e.composedPath() : e.path;
    h && p.target && p.target.shadowRoot && m && (u = m[0]);
    const f = n.noSwipingSelector
        ? n.noSwipingSelector
        : `.${n.noSwipingClass}`,
      v = !(!p.target || !p.target.shadowRoot);
    if (
      n.noSwiping &&
      (v
        ? (function (e, t = this) {
            return (function t(s) {
              if (!s || s === a() || s === l()) return null;
              s.assignedSlot && (s = s.assignedSlot);
              const i = s.closest(e);
              return i || s.getRootNode ? i || t(s.getRootNode().host) : null;
            })(t);
          })(f, u)
        : u.closest(f))
    )
      return void (t.allowClick = !0);
    if (n.swipeHandler && !u.closest(n.swipeHandler)) return;
    (o.currentX = p.pageX), (o.currentY = p.pageY);
    const g = o.currentX,
      w = o.currentY,
      b = n.edgeSwipeDetection || n.iOSEdgeSwipeDetection,
      S = n.edgeSwipeThreshold || n.iOSEdgeSwipeThreshold;
    if (b && (g <= S || g >= i.innerWidth - S)) {
      if ("prevent" !== b) return;
      e.preventDefault();
    }
    Object.assign(r, {
      isTouched: !0,
      isMoved: !1,
      allowTouchCallbacks: !0,
      isScrolling: void 0,
      startMoving: void 0,
    }),
      (o.startX = g),
      (o.startY = w),
      (r.touchStartTime = c()),
      (t.allowClick = !0),
      t.updateSize(),
      (t.swipeDirection = void 0),
      n.threshold > 0 && (r.allowThresholdMove = !1);
    let T = !0;
    u.matches(r.focusableElements) &&
      ((T = !1), "SELECT" === u.nodeName && (r.isTouched = !1)),
      s.activeElement &&
        s.activeElement.matches(r.focusableElements) &&
        s.activeElement !== u &&
        s.activeElement.blur();
    const y = T && t.allowTouchMove && n.touchStartPreventDefault;
    (!n.touchStartForcePreventDefault && !y) ||
      u.isContentEditable ||
      p.preventDefault(),
      n.freeMode &&
        n.freeMode.enabled &&
        t.freeMode &&
        t.animating &&
        !n.cssMode &&
        t.freeMode.onTouchStart(),
      t.emit("touchStart", p);
  }
  function j(e) {
    const t = a(),
      s = this,
      i = s.touchEventsData,
      { params: r, touches: n, rtlTranslate: o, enabled: l } = s;
    if (!l) return;
    if (!r.simulateTouch && "mouse" === e.pointerType) return;
    let d = e;
    if ((d.originalEvent && (d = d.originalEvent), !i.isTouched))
      return void (
        i.startMoving &&
        i.isScrolling &&
        s.emit("touchMoveOpposite", d)
      );
    const p = i.evCache.findIndex((e) => e.pointerId === d.pointerId);
    p >= 0 && (i.evCache[p] = d);
    const u = i.evCache.length > 1 ? i.evCache[0] : d,
      h = u.pageX,
      m = u.pageY;
    if (d.preventedByNestedSwiper) return (n.startX = h), void (n.startY = m);
    if (!s.allowTouchMove)
      return (
        d.target.matches(i.focusableElements) || (s.allowClick = !1),
        void (
          i.isTouched &&
          (Object.assign(n, {
            startX: h,
            startY: m,
            prevX: s.touches.currentX,
            prevY: s.touches.currentY,
            currentX: h,
            currentY: m,
          }),
          (i.touchStartTime = c()))
        )
      );
    if (r.touchReleaseOnEdges && !r.loop)
      if (s.isVertical()) {
        if (
          (m < n.startY && s.translate <= s.maxTranslate()) ||
          (m > n.startY && s.translate >= s.minTranslate())
        )
          return (i.isTouched = !1), void (i.isMoved = !1);
      } else if (
        (h < n.startX && s.translate <= s.maxTranslate()) ||
        (h > n.startX && s.translate >= s.minTranslate())
      )
        return;
    if (
      t.activeElement &&
      d.target === t.activeElement &&
      d.target.matches(i.focusableElements)
    )
      return (i.isMoved = !0), void (s.allowClick = !1);
    if (
      (i.allowTouchCallbacks && s.emit("touchMove", d),
      d.targetTouches && d.targetTouches.length > 1)
    )
      return;
    (n.currentX = h), (n.currentY = m);
    const f = n.currentX - n.startX,
      v = n.currentY - n.startY;
    if (s.params.threshold && Math.sqrt(f ** 2 + v ** 2) < s.params.threshold)
      return;
    if (void 0 === i.isScrolling) {
      let e;
      (s.isHorizontal() && n.currentY === n.startY) ||
      (s.isVertical() && n.currentX === n.startX)
        ? (i.isScrolling = !1)
        : f * f + v * v >= 25 &&
          ((e = (180 * Math.atan2(Math.abs(v), Math.abs(f))) / Math.PI),
          (i.isScrolling = s.isHorizontal()
            ? e > r.touchAngle
            : 90 - e > r.touchAngle));
    }
    if (
      (i.isScrolling && s.emit("touchMoveOpposite", d),
      void 0 === i.startMoving &&
        ((n.currentX === n.startX && n.currentY === n.startY) ||
          (i.startMoving = !0)),
      i.isScrolling ||
        (s.zoom &&
          s.params.zoom &&
          s.params.zoom.enabled &&
          i.evCache.length > 1))
    )
      return void (i.isTouched = !1);
    if (!i.startMoving) return;
    (s.allowClick = !1),
      !r.cssMode && d.cancelable && d.preventDefault(),
      r.touchMoveStopPropagation && !r.nested && d.stopPropagation();
    let g = s.isHorizontal() ? f : v,
      w = s.isHorizontal()
        ? n.currentX - n.previousX
        : n.currentY - n.previousY;
    r.oneWayMovement &&
      ((g = Math.abs(g) * (o ? 1 : -1)), (w = Math.abs(w) * (o ? 1 : -1))),
      (n.diff = g),
      (g *= r.touchRatio),
      o && ((g = -g), (w = -w));
    const b = s.touchesDirection;
    (s.swipeDirection = g > 0 ? "prev" : "next"),
      (s.touchesDirection = w > 0 ? "prev" : "next");
    const S = s.params.loop && !r.cssMode;
    if (!i.isMoved) {
      if (
        (S && s.loopFix({ direction: s.swipeDirection }),
        (i.startTranslate = s.getTranslate()),
        s.setTransition(0),
        s.animating)
      ) {
        const e = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0,
        });
        s.wrapperEl.dispatchEvent(e);
      }
      (i.allowMomentumBounce = !1),
        !r.grabCursor ||
          (!0 !== s.allowSlideNext && !0 !== s.allowSlidePrev) ||
          s.setGrabCursor(!0),
        s.emit("sliderFirstMove", d);
    }
    let T;
    i.isMoved &&
      b !== s.touchesDirection &&
      S &&
      Math.abs(g) >= 1 &&
      (s.loopFix({ direction: s.swipeDirection, setTranslate: !0 }), (T = !0)),
      s.emit("sliderMove", d),
      (i.isMoved = !0),
      (i.currentTranslate = g + i.startTranslate);
    let y = !0,
      x = r.resistanceRatio;
    if (
      (r.touchReleaseOnEdges && (x = 0),
      g > 0
        ? (S &&
            !T &&
            i.currentTranslate >
              (r.centeredSlides
                ? s.minTranslate() - s.size / 2
                : s.minTranslate()) &&
            s.loopFix({
              direction: "prev",
              setTranslate: !0,
              activeSlideIndex: 0,
            }),
          i.currentTranslate > s.minTranslate() &&
            ((y = !1),
            r.resistance &&
              (i.currentTranslate =
                s.minTranslate() -
                1 +
                (-s.minTranslate() + i.startTranslate + g) ** x)))
        : g < 0 &&
          (S &&
            !T &&
            i.currentTranslate <
              (r.centeredSlides
                ? s.maxTranslate() + s.size / 2
                : s.maxTranslate()) &&
            s.loopFix({
              direction: "next",
              setTranslate: !0,
              activeSlideIndex:
                s.slides.length -
                ("auto" === r.slidesPerView
                  ? s.slidesPerViewDynamic()
                  : Math.ceil(parseFloat(r.slidesPerView, 10))),
            }),
          i.currentTranslate < s.maxTranslate() &&
            ((y = !1),
            r.resistance &&
              (i.currentTranslate =
                s.maxTranslate() +
                1 -
                (s.maxTranslate() - i.startTranslate - g) ** x))),
      y && (d.preventedByNestedSwiper = !0),
      !s.allowSlideNext &&
        "next" === s.swipeDirection &&
        i.currentTranslate < i.startTranslate &&
        (i.currentTranslate = i.startTranslate),
      !s.allowSlidePrev &&
        "prev" === s.swipeDirection &&
        i.currentTranslate > i.startTranslate &&
        (i.currentTranslate = i.startTranslate),
      s.allowSlidePrev ||
        s.allowSlideNext ||
        (i.currentTranslate = i.startTranslate),
      r.threshold > 0)
    ) {
      if (!(Math.abs(g) > r.threshold || i.allowThresholdMove))
        return void (i.currentTranslate = i.startTranslate);
      if (!i.allowThresholdMove)
        return (
          (i.allowThresholdMove = !0),
          (n.startX = n.currentX),
          (n.startY = n.currentY),
          (i.currentTranslate = i.startTranslate),
          void (n.diff = s.isHorizontal()
            ? n.currentX - n.startX
            : n.currentY - n.startY)
        );
    }
    r.followFinger &&
      !r.cssMode &&
      (((r.freeMode && r.freeMode.enabled && s.freeMode) ||
        r.watchSlidesProgress) &&
        (s.updateActiveIndex(), s.updateSlidesClasses()),
      r.freeMode &&
        r.freeMode.enabled &&
        s.freeMode &&
        s.freeMode.onTouchMove(),
      s.updateProgress(i.currentTranslate),
      s.setTranslate(i.currentTranslate));
  }
  function D(e) {
    const t = this,
      s = t.touchEventsData,
      i = s.evCache.findIndex((t) => t.pointerId === e.pointerId);
    if (
      (i >= 0 && s.evCache.splice(i, 1),
      ["pointercancel", "pointerout", "pointerleave"].includes(e.type))
    ) {
      if (
        !(
          "pointercancel" === e.type &&
          (t.browser.isSafari || t.browser.isWebView)
        )
      )
        return;
    }
    const {
      params: r,
      touches: n,
      rtlTranslate: a,
      slidesGrid: o,
      enabled: l,
    } = t;
    if (!l) return;
    if (!r.simulateTouch && "mouse" === e.pointerType) return;
    let p = e;
    if (
      (p.originalEvent && (p = p.originalEvent),
      s.allowTouchCallbacks && t.emit("touchEnd", p),
      (s.allowTouchCallbacks = !1),
      !s.isTouched)
    )
      return (
        s.isMoved && r.grabCursor && t.setGrabCursor(!1),
        (s.isMoved = !1),
        void (s.startMoving = !1)
      );
    r.grabCursor &&
      s.isMoved &&
      s.isTouched &&
      (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
      t.setGrabCursor(!1);
    const u = c(),
      h = u - s.touchStartTime;
    if (t.allowClick) {
      const e = p.path || (p.composedPath && p.composedPath());
      t.updateClickedSlide((e && e[0]) || p.target),
        t.emit("tap click", p),
        h < 300 &&
          u - s.lastClickTime < 300 &&
          t.emit("doubleTap doubleClick", p);
    }
    if (
      ((s.lastClickTime = c()),
      d(() => {
        t.destroyed || (t.allowClick = !0);
      }),
      !s.isTouched ||
        !s.isMoved ||
        !t.swipeDirection ||
        0 === n.diff ||
        s.currentTranslate === s.startTranslate)
    )
      return (s.isTouched = !1), (s.isMoved = !1), void (s.startMoving = !1);
    let m;
    if (
      ((s.isTouched = !1),
      (s.isMoved = !1),
      (s.startMoving = !1),
      (m = r.followFinger
        ? a
          ? t.translate
          : -t.translate
        : -s.currentTranslate),
      r.cssMode)
    )
      return;
    if (r.freeMode && r.freeMode.enabled)
      return void t.freeMode.onTouchEnd({ currentPos: m });
    let f = 0,
      v = t.slidesSizesGrid[0];
    for (
      let e = 0;
      e < o.length;
      e += e < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup
    ) {
      const t = e < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
      void 0 !== o[e + t]
        ? m >= o[e] && m < o[e + t] && ((f = e), (v = o[e + t] - o[e]))
        : m >= o[e] && ((f = e), (v = o[o.length - 1] - o[o.length - 2]));
    }
    let g = null,
      w = null;
    r.rewind &&
      (t.isBeginning
        ? (w =
            r.virtual && r.virtual.enabled && t.virtual
              ? t.virtual.slides.length - 1
              : t.slides.length - 1)
        : t.isEnd && (g = 0));
    const b = (m - o[f]) / v,
      S = f < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
    if (h > r.longSwipesMs) {
      if (!r.longSwipes) return void t.slideTo(t.activeIndex);
      "next" === t.swipeDirection &&
        (b >= r.longSwipesRatio
          ? t.slideTo(r.rewind && t.isEnd ? g : f + S)
          : t.slideTo(f)),
        "prev" === t.swipeDirection &&
          (b > 1 - r.longSwipesRatio
            ? t.slideTo(f + S)
            : null !== w && b < 0 && Math.abs(b) > r.longSwipesRatio
            ? t.slideTo(w)
            : t.slideTo(f));
    } else {
      if (!r.shortSwipes) return void t.slideTo(t.activeIndex);
      t.navigation &&
      (p.target === t.navigation.nextEl || p.target === t.navigation.prevEl)
        ? p.target === t.navigation.nextEl
          ? t.slideTo(f + S)
          : t.slideTo(f)
        : ("next" === t.swipeDirection && t.slideTo(null !== g ? g : f + S),
          "prev" === t.swipeDirection && t.slideTo(null !== w ? w : f));
    }
  }
  function V() {
    const e = this,
      { params: t, el: s } = e;
    if (s && 0 === s.offsetWidth) return;
    t.breakpoints && e.setBreakpoint();
    const { allowSlideNext: i, allowSlidePrev: r, snapGrid: n } = e,
      a = e.virtual && e.params.virtual.enabled;
    (e.allowSlideNext = !0),
      (e.allowSlidePrev = !0),
      e.updateSize(),
      e.updateSlides(),
      e.updateSlidesClasses();
    const o = a && t.loop;
    !("auto" === t.slidesPerView || t.slidesPerView > 1) ||
    !e.isEnd ||
    e.isBeginning ||
    e.params.centeredSlides ||
    o
      ? e.params.loop && !a
        ? e.slideToLoop(e.realIndex, 0, !1, !0)
        : e.slideTo(e.activeIndex, 0, !1, !0)
      : e.slideTo(e.slides.length - 1, 0, !1, !0),
      e.autoplay &&
        e.autoplay.running &&
        e.autoplay.paused &&
        (clearTimeout(e.autoplay.resizeTimeout),
        (e.autoplay.resizeTimeout = setTimeout(() => {
          e.autoplay &&
            e.autoplay.running &&
            e.autoplay.paused &&
            e.autoplay.resume();
        }, 500))),
      (e.allowSlidePrev = r),
      (e.allowSlideNext = i),
      e.params.watchOverflow && n !== e.snapGrid && e.checkOverflow();
  }
  function $(e) {
    const t = this;
    t.enabled &&
      (t.allowClick ||
        (t.params.preventClicks && e.preventDefault(),
        t.params.preventClicksPropagation &&
          t.animating &&
          (e.stopPropagation(), e.stopImmediatePropagation())));
  }
  function F() {
    const e = this,
      { wrapperEl: t, rtlTranslate: s, enabled: i } = e;
    if (!i) return;
    let r;
    (e.previousTranslate = e.translate),
      e.isHorizontal()
        ? (e.translate = -t.scrollLeft)
        : (e.translate = -t.scrollTop),
      0 === e.translate && (e.translate = 0),
      e.updateActiveIndex(),
      e.updateSlidesClasses();
    const n = e.maxTranslate() - e.minTranslate();
    (r = 0 === n ? 0 : (e.translate - e.minTranslate()) / n),
      r !== e.progress && e.updateProgress(s ? -e.translate : e.translate),
      e.emit("setTranslate", e.translate, !1);
  }
  function B(e) {
    const t = this;
    P(t, e.target),
      t.params.cssMode ||
        ("auto" !== t.params.slidesPerView && !t.params.autoHeight) ||
        t.update();
  }
  let N = !1;
  function H() {}
  const q = (e, t) => {
    const s = a(),
      { params: i, el: r, wrapperEl: n, device: o } = e,
      l = !!i.nested,
      d = "on" === t ? "addEventListener" : "removeEventListener",
      c = t;
    r[d]("pointerdown", e.onTouchStart, { passive: !1 }),
      s[d]("pointermove", e.onTouchMove, { passive: !1, capture: l }),
      s[d]("pointerup", e.onTouchEnd, { passive: !0 }),
      s[d]("pointercancel", e.onTouchEnd, { passive: !0 }),
      s[d]("pointerout", e.onTouchEnd, { passive: !0 }),
      s[d]("pointerleave", e.onTouchEnd, { passive: !0 }),
      (i.preventClicks || i.preventClicksPropagation) &&
        r[d]("click", e.onClick, !0),
      i.cssMode && n[d]("scroll", e.onScroll),
      i.updateOnWindowResize
        ? e[c](
            o.ios || o.android
              ? "resize orientationchange observerUpdate"
              : "resize observerUpdate",
            V,
            !0
          )
        : e[c]("observerUpdate", V, !0),
      r[d]("load", e.onLoad, { capture: !0 });
  };
  const R = (e, t) => e.grid && t.grid && t.grid.rows > 1;
  const W = {
    setBreakpoint: function () {
      const e = this,
        { realIndex: t, initialized: s, params: i, el: r } = e,
        n = i.breakpoints;
      if (!n || (n && 0 === Object.keys(n).length)) return;
      const a = e.getBreakpoint(n, e.params.breakpointsBase, e.el);
      if (!a || e.currentBreakpoint === a) return;
      const o = (a in n ? n[a] : void 0) || e.originalParams,
        l = R(e, i),
        d = R(e, o),
        c = i.enabled;
      l && !d
        ? (r.classList.remove(
            `${i.containerModifierClass}grid`,
            `${i.containerModifierClass}grid-column`
          ),
          e.emitContainerClasses())
        : !l &&
          d &&
          (r.classList.add(`${i.containerModifierClass}grid`),
          ((o.grid.fill && "column" === o.grid.fill) ||
            (!o.grid.fill && "column" === i.grid.fill)) &&
            r.classList.add(`${i.containerModifierClass}grid-column`),
          e.emitContainerClasses()),
        ["navigation", "pagination", "scrollbar"].forEach((t) => {
          if (void 0 === o[t]) return;
          const s = i[t] && i[t].enabled,
            r = o[t] && o[t].enabled;
          s && !r && e[t].disable(), !s && r && e[t].enable();
        });
      const p = o.direction && o.direction !== i.direction,
        u = i.loop && (o.slidesPerView !== i.slidesPerView || p);
      p && s && e.changeDirection(), h(e.params, o);
      const m = e.params.enabled;
      Object.assign(e, {
        allowTouchMove: e.params.allowTouchMove,
        allowSlideNext: e.params.allowSlideNext,
        allowSlidePrev: e.params.allowSlidePrev,
      }),
        c && !m ? e.disable() : !c && m && e.enable(),
        (e.currentBreakpoint = a),
        e.emit("_beforeBreakpoint", o),
        u && s && (e.loopDestroy(), e.loopCreate(t), e.updateSlides()),
        e.emit("breakpoint", o);
    },
    getBreakpoint: function (e, t = "window", s) {
      if (!e || ("container" === t && !s)) return;
      let i = !1;
      const r = l(),
        n = "window" === t ? r.innerHeight : s.clientHeight,
        a = Object.keys(e).map((e) => {
          if ("string" == typeof e && 0 === e.indexOf("@")) {
            const t = parseFloat(e.substr(1));
            return { value: n * t, point: e };
          }
          return { value: e, point: e };
        });
      a.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
      for (let e = 0; e < a.length; e += 1) {
        const { point: n, value: o } = a[e];
        "window" === t
          ? r.matchMedia(`(min-width: ${o}px)`).matches && (i = n)
          : o <= s.clientWidth && (i = n);
      }
      return i || "max";
    },
  };
  const Y = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopedSlides: null,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1,
  };
  function X(e, t) {
    return function (s = {}) {
      const i = Object.keys(s)[0],
        r = s[i];
      "object" == typeof r && null !== r
        ? (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 &&
            !0 === e[i] &&
            (e[i] = { auto: !0 }),
          i in e && "enabled" in r
            ? (!0 === e[i] && (e[i] = { enabled: !0 }),
              "object" != typeof e[i] ||
                "enabled" in e[i] ||
                (e[i].enabled = !0),
              e[i] || (e[i] = { enabled: !1 }),
              h(t, s))
            : h(t, s))
        : h(t, s);
    };
  }
  const U = {
      eventsEmitter: M,
      update: L,
      translate: I,
      transition: {
        setTransition: function (e, t) {
          const s = this;
          s.params.cssMode || (s.wrapperEl.style.transitionDuration = `${e}ms`),
            s.emit("setTransition", e, t);
        },
        transitionStart: function (e = !0, t) {
          const s = this,
            { params: i } = s;
          i.cssMode ||
            (i.autoHeight && s.updateAutoHeight(),
            _({ swiper: s, runCallbacks: e, direction: t, step: "Start" }));
        },
        transitionEnd: function (e = !0, t) {
          const s = this,
            { params: i } = s;
          (s.animating = !1),
            i.cssMode ||
              (s.setTransition(0),
              _({ swiper: s, runCallbacks: e, direction: t, step: "End" }));
        },
      },
      slide: A,
      loop: z,
      grabCursor: {
        setGrabCursor: function (e) {
          const t = this;
          if (
            !t.params.simulateTouch ||
            (t.params.watchOverflow && t.isLocked) ||
            t.params.cssMode
          )
            return;
          const s =
            "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
          t.isElement && (t.__preventObserver__ = !0),
            (s.style.cursor = "move"),
            (s.style.cursor = e ? "grabbing" : "grab"),
            t.isElement &&
              requestAnimationFrame(() => {
                t.__preventObserver__ = !1;
              });
        },
        unsetGrabCursor: function () {
          const e = this;
          (e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e.isElement && (e.__preventObserver__ = !0),
            (e[
              "container" === e.params.touchEventsTarget ? "el" : "wrapperEl"
            ].style.cursor = ""),
            e.isElement &&
              requestAnimationFrame(() => {
                e.__preventObserver__ = !1;
              }));
        },
      },
      events: {
        attachEvents: function () {
          const e = this,
            t = a(),
            { params: s } = e;
          (e.onTouchStart = G.bind(e)),
            (e.onTouchMove = j.bind(e)),
            (e.onTouchEnd = D.bind(e)),
            s.cssMode && (e.onScroll = F.bind(e)),
            (e.onClick = $.bind(e)),
            (e.onLoad = B.bind(e)),
            N || (t.addEventListener("touchstart", H), (N = !0)),
            q(e, "on");
        },
        detachEvents: function () {
          q(this, "off");
        },
      },
      breakpoints: W,
      checkOverflow: {
        checkOverflow: function () {
          const e = this,
            { isLocked: t, params: s } = e,
            { slidesOffsetBefore: i } = s;
          if (i) {
            const t = e.slides.length - 1,
              s = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * i;
            e.isLocked = e.size > s;
          } else e.isLocked = 1 === e.snapGrid.length;
          !0 === s.allowSlideNext && (e.allowSlideNext = !e.isLocked),
            !0 === s.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
            t && t !== e.isLocked && (e.isEnd = !1),
            t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
        },
      },
      classes: {
        addClasses: function () {
          const e = this,
            { classNames: t, params: s, rtl: i, el: r, device: n } = e,
            a = (function (e, t) {
              const s = [];
              return (
                e.forEach((e) => {
                  "object" == typeof e
                    ? Object.keys(e).forEach((i) => {
                        e[i] && s.push(t + i);
                      })
                    : "string" == typeof e && s.push(t + e);
                }),
                s
              );
            })(
              [
                "initialized",
                s.direction,
                { "free-mode": e.params.freeMode && s.freeMode.enabled },
                { autoheight: s.autoHeight },
                { rtl: i },
                { grid: s.grid && s.grid.rows > 1 },
                {
                  "grid-column":
                    s.grid && s.grid.rows > 1 && "column" === s.grid.fill,
                },
                { android: n.android },
                { ios: n.ios },
                { "css-mode": s.cssMode },
                { centered: s.cssMode && s.centeredSlides },
                { "watch-progress": s.watchSlidesProgress },
              ],
              s.containerModifierClass
            );
          t.push(...a), r.classList.add(...t), e.emitContainerClasses();
        },
        removeClasses: function () {
          const { el: e, classNames: t } = this;
          e.classList.remove(...t), this.emitContainerClasses();
        },
      },
    },
    J = {};
  class Swiper {
    constructor(...e) {
      let t, s;
      1 === e.length &&
      e[0].constructor &&
      "Object" === Object.prototype.toString.call(e[0]).slice(8, -1)
        ? (s = e[0])
        : ([t, s] = e),
        s || (s = {}),
        (s = h({}, s)),
        t && !s.el && (s.el = t);
      const i = a();
      if (
        s.el &&
        "string" == typeof s.el &&
        i.querySelectorAll(s.el).length > 1
      ) {
        const e = [];
        return (
          i.querySelectorAll(s.el).forEach((t) => {
            const i = h({}, s, { el: t });
            e.push(new Swiper(i));
          }),
          e
        );
      }
      const r = this;
      (r.__swiper__ = !0),
        (r.support = x()),
        (r.device = C({ userAgent: s.userAgent })),
        (r.browser = E()),
        (r.eventsListeners = {}),
        (r.eventsAnyListeners = []),
        (r.modules = [...r.__modules__]),
        s.modules && Array.isArray(s.modules) && r.modules.push(...s.modules);
      const n = {};
      r.modules.forEach((e) => {
        e({
          params: s,
          swiper: r,
          extendParams: X(s, n),
          on: r.on.bind(r),
          once: r.once.bind(r),
          off: r.off.bind(r),
          emit: r.emit.bind(r),
        });
      });
      const o = h({}, Y, n);
      return (
        (r.params = h({}, o, J, s)),
        (r.originalParams = h({}, r.params)),
        (r.passedParams = h({}, s)),
        r.params &&
          r.params.on &&
          Object.keys(r.params.on).forEach((e) => {
            r.on(e, r.params.on[e]);
          }),
        r.params && r.params.onAny && r.onAny(r.params.onAny),
        Object.assign(r, {
          enabled: r.params.enabled,
          el: t,
          classNames: [],
          slides: [],
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          isHorizontal: () => "horizontal" === r.params.direction,
          isVertical: () => "vertical" === r.params.direction,
          activeIndex: 0,
          realIndex: 0,
          isBeginning: !0,
          isEnd: !1,
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: !1,
          cssOverflowAdjustment() {
            return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
          },
          allowSlideNext: r.params.allowSlideNext,
          allowSlidePrev: r.params.allowSlidePrev,
          touchEventsData: {
            isTouched: void 0,
            isMoved: void 0,
            allowTouchCallbacks: void 0,
            touchStartTime: void 0,
            isScrolling: void 0,
            currentTranslate: void 0,
            startTranslate: void 0,
            allowThresholdMove: void 0,
            focusableElements: r.params.focusableElements,
            lastClickTime: 0,
            clickTimeout: void 0,
            velocities: [],
            allowMomentumBounce: void 0,
            startMoving: void 0,
            evCache: [],
          },
          allowClick: !0,
          allowTouchMove: r.params.allowTouchMove,
          touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
          imagesToLoad: [],
          imagesLoaded: 0,
        }),
        r.emit("_swiper"),
        r.params.init && r.init(),
        r
      );
    }
    getSlideIndex(e) {
      const { slidesEl: t, params: s } = this,
        i = w(v(t, `.${s.slideClass}, swiper-slide`)[0]);
      return w(e) - i;
    }
    getSlideIndexByData(e) {
      return this.getSlideIndex(
        this.slides.filter(
          (t) => 1 * t.getAttribute("data-swiper-slide-index") === e
        )[0]
      );
    }
    recalcSlides() {
      const { slidesEl: e, params: t } = this;
      this.slides = v(e, `.${t.slideClass}, swiper-slide`);
    }
    enable() {
      const e = this;
      e.enabled ||
        ((e.enabled = !0),
        e.params.grabCursor && e.setGrabCursor(),
        e.emit("enable"));
    }
    disable() {
      const e = this;
      e.enabled &&
        ((e.enabled = !1),
        e.params.grabCursor && e.unsetGrabCursor(),
        e.emit("disable"));
    }
    setProgress(e, t) {
      const s = this;
      e = Math.min(Math.max(e, 0), 1);
      const i = s.minTranslate(),
        r = (s.maxTranslate() - i) * e + i;
      s.translateTo(r, void 0 === t ? 0 : t),
        s.updateActiveIndex(),
        s.updateSlidesClasses();
    }
    emitContainerClasses() {
      const e = this;
      if (!e.params._emitClasses || !e.el) return;
      const t = e.el.className
        .split(" ")
        .filter(
          (t) =>
            0 === t.indexOf("swiper") ||
            0 === t.indexOf(e.params.containerModifierClass)
        );
      e.emit("_containerClasses", t.join(" "));
    }
    getSlideClasses(e) {
      const t = this;
      return t.destroyed
        ? ""
        : e.className
            .split(" ")
            .filter(
              (e) =>
                0 === e.indexOf("swiper-slide") ||
                0 === e.indexOf(t.params.slideClass)
            )
            .join(" ");
    }
    emitSlidesClasses() {
      const e = this;
      if (!e.params._emitClasses || !e.el) return;
      const t = [];
      e.slides.forEach((s) => {
        const i = e.getSlideClasses(s);
        t.push({ slideEl: s, classNames: i }), e.emit("_slideClass", s, i);
      }),
        e.emit("_slideClasses", t);
    }
    slidesPerViewDynamic(e = "current", t = !1) {
      const {
        params: s,
        slides: i,
        slidesGrid: r,
        slidesSizesGrid: n,
        size: a,
        activeIndex: o,
      } = this;
      let l = 1;
      if (s.centeredSlides) {
        let e,
          t = i[o] ? i[o].swiperSlideSize : 0;
        for (let s = o + 1; s < i.length; s += 1)
          i[s] &&
            !e &&
            ((t += i[s].swiperSlideSize), (l += 1), t > a && (e = !0));
        for (let s = o - 1; s >= 0; s -= 1)
          i[s] &&
            !e &&
            ((t += i[s].swiperSlideSize), (l += 1), t > a && (e = !0));
      } else if ("current" === e)
        for (let e = o + 1; e < i.length; e += 1) {
          (t ? r[e] + n[e] - r[o] < a : r[e] - r[o] < a) && (l += 1);
        }
      else
        for (let e = o - 1; e >= 0; e -= 1) {
          r[o] - r[e] < a && (l += 1);
        }
      return l;
    }
    update() {
      const e = this;
      if (!e || e.destroyed) return;
      const { snapGrid: t, params: s } = e;
      function i() {
        const t = e.rtlTranslate ? -1 * e.translate : e.translate,
          s = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
        e.setTranslate(s), e.updateActiveIndex(), e.updateSlidesClasses();
      }
      let r;
      if (
        (s.breakpoints && e.setBreakpoint(),
        [...e.el.querySelectorAll('[loading="lazy"]')].forEach((t) => {
          t.complete && P(e, t);
        }),
        e.updateSize(),
        e.updateSlides(),
        e.updateProgress(),
        e.updateSlidesClasses(),
        s.freeMode && s.freeMode.enabled && !s.cssMode)
      )
        i(), s.autoHeight && e.updateAutoHeight();
      else {
        if (
          ("auto" === s.slidesPerView || s.slidesPerView > 1) &&
          e.isEnd &&
          !s.centeredSlides
        ) {
          const t =
            e.virtual && s.virtual.enabled ? e.virtual.slides : e.slides;
          r = e.slideTo(t.length - 1, 0, !1, !0);
        } else r = e.slideTo(e.activeIndex, 0, !1, !0);
        r || i();
      }
      s.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
        e.emit("update");
    }
    changeDirection(e, t = !0) {
      const s = this,
        i = s.params.direction;
      return (
        e || (e = "horizontal" === i ? "vertical" : "horizontal"),
        e === i ||
          ("horizontal" !== e && "vertical" !== e) ||
          (s.el.classList.remove(`${s.params.containerModifierClass}${i}`),
          s.el.classList.add(`${s.params.containerModifierClass}${e}`),
          s.emitContainerClasses(),
          (s.params.direction = e),
          s.slides.forEach((t) => {
            "vertical" === e ? (t.style.width = "") : (t.style.height = "");
          }),
          s.emit("changeDirection"),
          t && s.update()),
        s
      );
    }
    changeLanguageDirection(e) {
      const t = this;
      (t.rtl && "rtl" === e) ||
        (!t.rtl && "ltr" === e) ||
        ((t.rtl = "rtl" === e),
        (t.rtlTranslate = "horizontal" === t.params.direction && t.rtl),
        t.rtl
          ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`),
            (t.el.dir = "rtl"))
          : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`),
            (t.el.dir = "ltr")),
        t.update());
    }
    mount(e) {
      const t = this;
      if (t.mounted) return !0;
      let s = e || t.params.el;
      if (("string" == typeof s && (s = document.querySelector(s)), !s))
        return !1;
      (s.swiper = t), s.shadowEl && (t.isElement = !0);
      const i = () =>
        `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
      let r = (() => {
        if (s && s.shadowRoot && s.shadowRoot.querySelector) {
          return s.shadowRoot.querySelector(i());
        }
        return v(s, i())[0];
      })();
      return (
        !r &&
          t.params.createElements &&
          ((r = (function (e, t = []) {
            const s = document.createElement(e);
            return s.classList.add(...(Array.isArray(t) ? t : [t])), s;
          })("div", t.params.wrapperClass)),
          s.append(r),
          v(s, `.${t.params.slideClass}`).forEach((e) => {
            r.append(e);
          })),
        Object.assign(t, {
          el: s,
          wrapperEl: r,
          slidesEl: t.isElement ? s : r,
          mounted: !0,
          rtl: "rtl" === s.dir.toLowerCase() || "rtl" === g(s, "direction"),
          rtlTranslate:
            "horizontal" === t.params.direction &&
            ("rtl" === s.dir.toLowerCase() || "rtl" === g(s, "direction")),
          wrongRTL: "-webkit-box" === g(r, "display"),
        }),
        !0
      );
    }
    init(e) {
      const t = this;
      if (t.initialized) return t;
      return (
        !1 === t.mount(e) ||
          (t.emit("beforeInit"),
          t.params.breakpoints && t.setBreakpoint(),
          t.addClasses(),
          t.updateSize(),
          t.updateSlides(),
          t.params.watchOverflow && t.checkOverflow(),
          t.params.grabCursor && t.enabled && t.setGrabCursor(),
          t.params.loop && t.virtual && t.params.virtual.enabled
            ? t.slideTo(
                t.params.initialSlide + t.virtual.slidesBefore,
                0,
                t.params.runCallbacksOnInit,
                !1,
                !0
              )
            : t.slideTo(
                t.params.initialSlide,
                0,
                t.params.runCallbacksOnInit,
                !1,
                !0
              ),
          t.params.loop && t.loopCreate(),
          t.attachEvents(),
          [...t.el.querySelectorAll('[loading="lazy"]')].forEach((e) => {
            e.complete
              ? P(t, e)
              : e.addEventListener("load", (e) => {
                  P(t, e.target);
                });
          }),
          O(t),
          (t.initialized = !0),
          O(t),
          t.emit("init"),
          t.emit("afterInit")),
        t
      );
    }
    destroy(e = !0, t = !0) {
      const s = this,
        { params: i, el: r, wrapperEl: n, slides: a } = s;
      return (
        void 0 === s.params ||
          s.destroyed ||
          (s.emit("beforeDestroy"),
          (s.initialized = !1),
          s.detachEvents(),
          i.loop && s.loopDestroy(),
          t &&
            (s.removeClasses(),
            r.removeAttribute("style"),
            n.removeAttribute("style"),
            a &&
              a.length &&
              a.forEach((e) => {
                e.classList.remove(
                  i.slideVisibleClass,
                  i.slideActiveClass,
                  i.slideNextClass,
                  i.slidePrevClass
                ),
                  e.removeAttribute("style"),
                  e.removeAttribute("data-swiper-slide-index");
              })),
          s.emit("destroy"),
          Object.keys(s.eventsListeners).forEach((e) => {
            s.off(e);
          }),
          !1 !== e &&
            ((s.el.swiper = null),
            (function (e) {
              const t = e;
              Object.keys(t).forEach((e) => {
                try {
                  t[e] = null;
                } catch (e) {}
                try {
                  delete t[e];
                } catch (e) {}
              });
            })(s)),
          (s.destroyed = !0)),
        null
      );
    }
    static extendDefaults(e) {
      h(J, e);
    }
    static get extendedDefaults() {
      return J;
    }
    static get defaults() {
      return Y;
    }
    static installModule(e) {
      Swiper.prototype.__modules__ || (Swiper.prototype.__modules__ = []);
      const t = Swiper.prototype.__modules__;
      "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
    }
    static use(e) {
      return Array.isArray(e)
        ? (e.forEach((e) => Swiper.installModule(e)), Swiper)
        : (Swiper.installModule(e), Swiper);
    }
  }
  Object.keys(U).forEach((e) => {
    Object.keys(U[e]).forEach((t) => {
      Swiper.prototype[t] = U[e][t];
    });
  }),
    Swiper.use([
      function ({ swiper: e, on: t, emit: s }) {
        const i = l();
        let r = null,
          n = null;
        const a = () => {
            e &&
              !e.destroyed &&
              e.initialized &&
              (s("beforeResize"), s("resize"));
          },
          o = () => {
            e && !e.destroyed && e.initialized && s("orientationchange");
          };
        t("init", () => {
          e.params.resizeObserver && void 0 !== i.ResizeObserver
            ? e &&
              !e.destroyed &&
              e.initialized &&
              ((r = new ResizeObserver((t) => {
                n = i.requestAnimationFrame(() => {
                  const { width: s, height: i } = e;
                  let r = s,
                    n = i;
                  t.forEach(
                    ({ contentBoxSize: t, contentRect: s, target: i }) => {
                      (i && i !== e.el) ||
                        ((r = s ? s.width : (t[0] || t).inlineSize),
                        (n = s ? s.height : (t[0] || t).blockSize));
                    }
                  ),
                    (r === s && n === i) || a();
                });
              })),
              r.observe(e.el))
            : (i.addEventListener("resize", a),
              i.addEventListener("orientationchange", o));
        }),
          t("destroy", () => {
            n && i.cancelAnimationFrame(n),
              r && r.unobserve && e.el && (r.unobserve(e.el), (r = null)),
              i.removeEventListener("resize", a),
              i.removeEventListener("orientationchange", o);
          });
      },
      function ({ swiper: e, extendParams: t, on: s, emit: i }) {
        const r = [],
          n = l(),
          a = (t, s = {}) => {
            const a = new (n.MutationObserver || n.WebkitMutationObserver)(
              (t) => {
                if (e.__preventObserver__) return;
                if (1 === t.length) return void i("observerUpdate", t[0]);
                const s = function () {
                  i("observerUpdate", t[0]);
                };
                n.requestAnimationFrame
                  ? n.requestAnimationFrame(s)
                  : n.setTimeout(s, 0);
              }
            );
            a.observe(t, {
              attributes: void 0 === s.attributes || s.attributes,
              childList: void 0 === s.childList || s.childList,
              characterData: void 0 === s.characterData || s.characterData,
            }),
              r.push(a);
          };
        t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
          s("init", () => {
            if (e.params.observer) {
              if (e.params.observeParents) {
                const t = (function (e, t) {
                  const s = [];
                  let i = e.parentElement;
                  for (; i; )
                    t ? i.matches(t) && s.push(i) : s.push(i),
                      (i = i.parentElement);
                  return s;
                })(e.el);
                for (let e = 0; e < t.length; e += 1) a(t[e]);
              }
              a(e.el, { childList: e.params.observeSlideChildren }),
                a(e.wrapperEl, { attributes: !1 });
            }
          }),
          s("destroy", () => {
            r.forEach((e) => {
              e.disconnect();
            }),
              r.splice(0, r.length);
          });
      },
    ]);
  function K({ swiper: e, extendParams: t, on: s }) {
    t({
      thumbs: {
        swiper: null,
        multipleActiveThumbs: !0,
        autoScrollOffset: 0,
        slideThumbActiveClass: "swiper-slide-thumb-active",
        thumbsContainerClass: "swiper-thumbs",
      },
    });
    let i = !1,
      r = !1;
    function n() {
      const t = e.thumbs.swiper;
      if (!t || t.destroyed) return;
      const s = t.clickedIndex,
        i = t.clickedSlide;
      if (i && i.classList.contains(e.params.thumbs.slideThumbActiveClass))
        return;
      if (null == s) return;
      let r;
      (r = t.params.loop
        ? parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10)
        : s),
        e.params.loop ? e.slideToLoop(r) : e.slideTo(r);
    }
    function o() {
      const { thumbs: t } = e.params;
      if (i) return !1;
      i = !0;
      const s = e.constructor;
      if (t.swiper instanceof s)
        (e.thumbs.swiper = t.swiper),
          Object.assign(e.thumbs.swiper.originalParams, {
            watchSlidesProgress: !0,
            slideToClickedSlide: !1,
          }),
          Object.assign(e.thumbs.swiper.params, {
            watchSlidesProgress: !0,
            slideToClickedSlide: !1,
          }),
          e.thumbs.swiper.update();
      else if (u(t.swiper)) {
        const i = Object.assign({}, t.swiper);
        Object.assign(i, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
          (e.thumbs.swiper = new s(i)),
          (r = !0);
      }
      return (
        e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass),
        e.thumbs.swiper.on("tap", n),
        !0
      );
    }
    function l(t) {
      const s = e.thumbs.swiper;
      if (!s || s.destroyed) return;
      const i =
        "auto" === s.params.slidesPerView
          ? s.slidesPerViewDynamic()
          : s.params.slidesPerView;
      let r = 1;
      const n = e.params.thumbs.slideThumbActiveClass;
      if (
        (e.params.slidesPerView > 1 &&
          !e.params.centeredSlides &&
          (r = e.params.slidesPerView),
        e.params.thumbs.multipleActiveThumbs || (r = 1),
        (r = Math.floor(r)),
        s.slides.forEach((e) => e.classList.remove(n)),
        s.params.loop || (s.params.virtual && s.params.virtual.enabled))
      )
        for (let t = 0; t < r; t += 1)
          v(
            s.slidesEl,
            `[data-swiper-slide-index="${e.realIndex + t}"]`
          ).forEach((e) => {
            e.classList.add(n);
          });
      else
        for (let t = 0; t < r; t += 1)
          s.slides[e.realIndex + t] &&
            s.slides[e.realIndex + t].classList.add(n);
      const a = e.params.thumbs.autoScrollOffset,
        o = a && !s.params.loop;
      if (e.realIndex !== s.realIndex || o) {
        const r = s.activeIndex;
        let n, l;
        if (s.params.loop) {
          const t = s.slides.filter(
            (t) =>
              t.getAttribute("data-swiper-slide-index") === `${e.realIndex}`
          )[0];
          (n = s.slides.indexOf(t)),
            (l = e.activeIndex > e.previousIndex ? "next" : "prev");
        } else (n = e.realIndex), (l = n > e.previousIndex ? "next" : "prev");
        o && (n += "next" === l ? a : -1 * a),
          s.visibleSlidesIndexes &&
            s.visibleSlidesIndexes.indexOf(n) < 0 &&
            (s.params.centeredSlides
              ? (n =
                  n > r ? n - Math.floor(i / 2) + 1 : n + Math.floor(i / 2) - 1)
              : n > r && s.params.slidesPerGroup,
            s.slideTo(n, t ? 0 : void 0));
      }
    }
    (e.thumbs = { swiper: null }),
      s("beforeInit", () => {
        const { thumbs: t } = e.params;
        if (t && t.swiper)
          if ("string" == typeof t.swiper || t.swiper instanceof HTMLElement) {
            const s = a(),
              i = () => {
                const i =
                  "string" == typeof t.swiper
                    ? s.querySelector(t.swiper)
                    : t.swiper;
                if (i && i.swiper) (t.swiper = i.swiper), o(), l(!0);
                else if (i) {
                  const s = (r) => {
                    (t.swiper = r.detail[0]),
                      i.removeEventListener("init", s),
                      o(),
                      l(!0),
                      t.swiper.update(),
                      e.update();
                  };
                  i.addEventListener("init", s);
                }
                return i;
              },
              r = () => {
                if (e.destroyed) return;
                i() || requestAnimationFrame(r);
              };
            requestAnimationFrame(r);
          } else o(), l(!0);
      }),
      s("slideChange update resize observerUpdate", () => {
        l();
      }),
      s("setTransition", (t, s) => {
        const i = e.thumbs.swiper;
        i && !i.destroyed && i.setTransition(s);
      }),
      s("beforeDestroy", () => {
        const t = e.thumbs.swiper;
        t && !t.destroyed && r && t.destroy();
      }),
      Object.assign(e.thumbs, { init: o, update: l });
  }
  function Q() {
    const e = document.querySelector(".js-product-recommendations");
    new IntersectionObserver(
      (t, s) => {
        if (!t[0].isIntersecting) return;
        s.unobserve(e);
        fetch(
          "{{ routes.product_recommendations_url }}?section_id={{ section.id }}&product_id={{ product.id }}&limit=10&intent=related"
        )
          .then((e) => e.text())
          .then((t) => {
            const s = document.createRange().createContextualFragment(t),
              i = s.querySelector(".js-product-recommendations");
            i && i.innerHTML.trim().length && e.append(s);
          })
          .catch((e) => {
            console.error(e);
          });
      },
      { rootMargin: "0px 0px 200px 0px" }
    ).observe(e);
  }
  s()
    .then(async () => {
      const e = document.querySelector(".js-product-gallery-thumbnails"),
        t = {
          slidesPerView: 5,
          loop: !1,
          spaceBetween: window.globalDesign.gutterUnit.mobile,
          breakpoints: {
            767: { 
              direction: "vertical",
              slidesPerView: "auto",
              spaceBetween: window.globalDesign.gutterUnit.desktop 
            },
          },
        };
      Object.assign(e, t), e.initialize();
      const s = document.querySelector(".js-product-gallery"),
        i = {
          spaceBetween: window.globalDesign.gutterUnit.mobile,
          slidesPerView: 1,
          loop: !1,
          thumbs: { swiper: e },
          breakpoints: {
            767: {
              slidesPerView: 1,
              spaceBetween: window.globalDesign.gutterUnit.desktop,
            },
          },
          modules: [K],
        };
      function r(e) {
        const t = s.swiper.slides.findIndex(({ dataset: t }) => t.mediaId == e);
        s.swiper.slideTo(t);
      }
      Object.assign(s, i), s.initialize();
      const n = new ObserverLite({ key: "productMainForm$" }),
        a = await n.once();
      a.subscribe(() => {
        r(a.variant?.featured_media?.id);
      }),
        r(a.variant?.featured_media?.id);
    })
    .catch((e) => {
      console.log(e);
    }),
    s()
      .then(() => {
        const e = document.querySelectorAll(".js-toggle-nav__btn"),
          t = document.querySelector(".js-product-below-fold-cards"),
          s = {
            slidesPerView: 1,
            pagination: {
              el: ".js-product-below-fold-cards__pagination",
              clickable: !0,
            },
            on: {
              slideChange: (t) => {
                ((t) => {
                  e.forEach((e) => {
                    e.classList.remove("toggle-nav__btn--active");
                  }),
                    e[t.activeIndex].classList.add("toggle-nav__btn--active");
                })(t);
              },
            },
          };
        Object.assign(t, s),
          t.initialize(),
          e.forEach((e) => {
            e.addEventListener("click", (s) => {
              s.preventDefault();
              const i = [].indexOf.call(e.parentElement.children, e);
              t.swiper.slideTo(i);
            });
          });
      })
      .catch((e) => {
        console.log(e);
      });
  var Z = self;
  for (var ee in t) Z[ee] = t[ee];
  t.__esModule && Object.defineProperty(Z, "__esModule", { value: !0 });
})();

// product bundle
function cartcount() {
  $.getJSON("/cart.js", function (cart) {
    var result = cart.item_count;
    $(".js-wbsk-sidebar-cart__cart-count").html(result);
  });
}
function dataupdate() {
  $.get("/cart?view=ajax-sidebar-cart", function (data) {
    $(".js-wbsk-sidebar-cart__cart-template").html(data);
  });
}

function commonTimeFun(matchingVariant) {
  const dd = matchingVariant.delivery_day.split("|");
  const upcoming_date = parseInt(dd[1]);

  var date = new Date();
  date.setDate(date.getDate() + upcoming_date);

  var formattedDate = date.toLocaleDateString("en-GB");
  // console.log("finalDate", formattedDate);
  var x = dd[0];
  var y = formattedDate.replace(dd[1]);
  var result = x + y;
  // $(".prod-below-atc__text").html(result);
  // document.querySelector(".prod-below-atc__text").innerHTML = result;
}

function updateDeliveryText(variantData, current_id) {
  var matchingVariant = variantData.metafields.find(function (variant) {
    return variant.id == current_id;
  });

  if (matchingVariant.status != "") {
    $(".bundle_product_add .js-product-main__atc").text(matchingVariant.status);
  } else {
    $(".bundle_product_add .js-product-main__atc").text("Add to cart");
  }

  const now = new Date();
  const hours = now.getHours();
  const currentTime = `${hours}:00:00`;

  if (hours < 18) {
    if (matchingVariant.delivery_day != "") {
      commonTimeFun(matchingVariant);
    } else {
      // $(".prod-below-atc__text").html("Order before 6pm for next day delivery");
    }
  } else {
    if (matchingVariant.delivery_day != "") {
      commonTimeFun(matchingVariant);
    } else {
      // $(".prod-below-atc__text").html("Order before 6pm for next day delivery");
    }
  }
}

if ($(".js-product-main-form form").hasClass("bundle_product_add")) {
  $(window).on("load", function () {
    var bundlevariantData = $("#bundle-variant-json").text();
    var variantData = JSON.parse(bundlevariantData);
    var current_id = variantData.metafields[0].id;
    updateDeliveryText(variantData, current_id);
  });
}

$(document).ready(function () {
  $("body").on("click", ".swatch_input", function (e) {
    var bundlevariantData = $("#bundle-variant-json").text();
    var variantData = JSON.parse(bundlevariantData);
    var current_id = $(this).attr("data-bundle-id");
    updateDeliveryText(variantData, current_id);
    $(this)
      .closest(".swatch")
      .find(".swatch_input")
      .each(function () {
        $(this).attr("checked", false);
      });
    $(this).attr("checked", true);
    var total = 0;
    $('.swatch_input[checked="checked"]').each(function () {
      var get_price = parseFloat($(this).data("bundle-price"));
      $(this).closest('.product_bundle_box').find('.b-card-main-price').text(Shopify.formatMoney(get_price, moneyfomat));
      total += get_price;

    });
    var get_dicount_price = parseInt($(".bundle_price_dicount").val());
    var priceplus = total;
    var dicountprice = get_dicount_price;
    var dget_price = priceplus * dicountprice;
    var final_price = priceplus - dicountprice;
    console.log("final_price",Shopify.formatMoney(final_price, moneyfomat));
    $(".bundle_dic_price").text(Shopify.formatMoney(final_price, moneyfomat));
    $(".bundle_total_price").text(Shopify.formatMoney(priceplus, moneyfomat));
  });

  $("body").on("click", ".remove_bundle", function (e) {
    event.preventDefault();
    var remove_id = $(this).attr("data-remove-id");
    console.log(remove_id);
    if (remove_id != "" && remove_id != undefined && remove_id != null) {
      $('[data-remove-id="' + remove_id + '"]').each(function (i, v) {
        var remove_line = $(v).attr("data-line_key");
        console.log(remove_line, "remove_line");
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: {
            id: remove_line,
            quantity: "0",
          },
          async: false,
          dataType: "json",
          success: function (data) {
            console.log(data, "data");
            cartcount();
            dataupdate();
          },
          error: function (data) {
            cartcount();
            dataupdate();
            console.log("error");
          },
        });
      });
    }
  });

  // review badge click
  $('.jdgm-preview-badge').click(function() {
    $('.accordion__title--reviews').trigger('click');
    
    const reviewsSection = $('.accordion__title--reviews');
        $('html, body').animate({
            scrollTop: reviewsSection.offset().top - 80
        }, 350);

    
  });
  
});

// ------------------ bundle product add to cart
function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

$("body").on(
  "click",
  ".bundle_product_add .js-product-main__atc",
  function (event) {
    event.preventDefault();
    let unique_no = getRandomNumber(10000000000, 10000000000000);
    var selectedProducts = {
      items: [],
    };
    var bundleid = $(".product_bundle_list").attr("data-bundleproduct-id");
    console.log(bundleid, "bundleid");
    $('.swatch_input[checked="checked"]').each(function () {
      var json = {};
      var get_id = $(this).attr("data-bundle-id");
      console.log(typeof get_id, "get_id");
      var get_quantity = $(".quantity_input").val();
      var get_propertiess = {
        Propertiesbundle: unique_no,
        _cs_bundle_id: bundleid,
      };
      json["id"] = get_id;
      json["quantity"] = get_quantity;
      json["properties"] = get_propertiess;
      selectedProducts.items.push(json);
    });
    $(".js-wbsk-sidebar-cart__open").trigger("click");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: selectedProducts,
      dataType: "json",
      success: function (data) {
        cartcount();
        dataupdate();
        if(typeof fire_cart_data !== 'undefined'){ fire_cart_data(1, 'all'); }

      },
      error: function (data) {
        cartcount();
        dataupdate();
        alert(data.responseJSON.description);
      },
    });
  }
);
